const km = {

  // ── Common / Global ──────────────────────────────────────────
  common: {
    appName: 'ERPhub',
    appTagline: 'ការគ្រប់គ្រងការលក់ ស្តុក និង POS ច្រើនសាខា',
    loading: 'កំពុងផ្ទុក...',
    saving: 'កំពុងរក្សាទុក…',
    save: 'រក្សាទុក',
    cancel: 'បោះបង់',
    delete: 'លុប',
    edit: 'កែសម្រួល',
    add: 'បន្ថែម',
    create: 'បង្កើត',
    update: 'ធ្វើបច្ចុប្បន្នភាព',
    search: 'ស្វែងរក…',
    filter: 'តម្រង',
    export: 'នាំចេញ CSV',
    print: 'បោះពុម្ព',
    refresh: 'ផ្ទុកឡើងវិញ',
    close: 'បិទ',
    back: 'ត្រឡប់',
    next: 'បន្ទាប់',
    prev: 'មុន',
    yes: 'បាទ/ចាស',
    no: 'ទេ',
    confirm: 'បញ្ជាក់',
    submit: 'ដាក់ស្នើ',
    reset: 'កំណត់ឡើងវិញ',
    clear: 'សម្អាត',
    view: 'មើល',
    detail: 'លម្អិត',
    actions: 'សកម្មភាព',
    status: 'ស្ថានភាព',
    date: 'កាលបរិច្ឆេទ',
    time: 'ពេលវេលា',
    name: 'ឈ្មោះ',
    code: 'លេខកូដ',
    type: 'ប្រភេទ',
    notes: 'កំណត់ចំណាំ',
    total: 'សរុប',
    subtotal: 'សរុបរង',
    discount: 'បញ្ចុះតម្លៃ',
    tax: 'ពន្ធ',
    amount: 'ចំនួន',
    price: 'តម្លៃ',
    qty: 'បរិមាណ',
    quantity: 'បរិមាណ',
    unit: 'ឯកតា',
    branch: 'សាខា',
    customer: 'អតិថិជន',
    product: 'ផលិតផល',
    noRecords: 'គ្មានទិន្នន័យ',
    noData: 'រកមិនឃើញទិន្នន័យ',
    accessDenied: 'ការចូលប្រើត្រូវបានបដិសេធ',
    contactAdmin: 'សូមទាក់ទងអ្នកគ្រប់គ្រង។',
    welcome: 'សូមស្វាគមន៍,',
    signOut: 'ចាកចេញ',
    language: 'ភាសា',
    required: '(ចាំបាច់)',
    all: 'ទាំងអស់',
    page: 'ទំព័រ',
    of: 'នៃ',
    showing: 'បង្ហាញ',
    results: 'លទ្ធផល',
    description: 'ការពិពណ៌នា',
    created: 'បានបង្កើត',
    updated: 'បានធ្វើបច្ចុប្បន្នភាព',
    deleted: 'បានលុប',
    failed: 'បរាជ័យ',
    active: 'សកម្ម',
    inactive: 'អសកម្ម',
    viewOnly: 'មើលប៉ុណ្ណោះ',
    deleteConfirm: 'លុបជាអចិន្ត្រៃយ៍?',
    nameRequired: 'ទាមទារឈ្មោះ',
    image: 'រូបភាព',
    uploadFailed: 'បញ្ចូលរូបភាពបរាជ័យ',
    uploaded: 'បានបញ្ចូល',
    remove: 'យកចេញ',
    apply: 'អនុវត្ត',
    today: 'ថ្ងៃនេះ',
    yesterday: 'ម្សិលមិញ',
    thisWeek: 'សប្ដាហ៍នេះ',
    thisMonth: 'ខែនេះ',
    last30: '30 ថ្ងៃចុងក្រោយ',
    allTime: 'ទាំងអស់',
    custom: 'កំណត់ខ្លួនឯង',
    from: 'ចាប់ពី',
    to: 'រហូតដល់',
    fromDate: 'ចាប់ពីថ្ងៃ',
    toDate: 'រហូតដល់ថ្ងៃ',
    id: 'លេខសម្គាល់',
    reference: 'លេខយោង',
    method: 'វិធី',
    value: 'តម្លៃ',
    count: 'ចំនួន',
    percent: 'ភាគរយ',
    sortOrder: 'លំដាប់តម្រៀប',
    priority: 'អាទិភាព',
    channel: 'ប្រព័ន្ធ',
    device: 'ឧបករណ៍',
    user: 'អ្នកប្រើប្រាស់',
    role: 'តួនាទី',
    currency: 'រូបិយប័ណ្ណ',
    rate: 'អត្រា',
    symbol: 'និមិត្តសញ្ញា',
    margin: 'ប្រាក់ចំណេញ',
    scheduled: 'កំណត់ពេល',
    automatic: 'ស្វ័យប្រវត្តិ',
    sent: 'បានផ្ញើ',
    unread: 'មិនទាន់អាន',
    analytics: 'ការវិភាគ',
    summary: 'សង្ខេប',
    balance: 'សមតុល្យ',
    rank: 'លំដាប់',
    revenue: 'ចំណូល',
    revenue2: 'ចំណូល',
    transactions: 'ប្រតិបត្តិការ',
    overview: 'ទិដ្ឋភាពទូទៅ',
    recent: 'ថ្មីៗ',
    recentActivity: 'សកម្មភាពថ្មីៗ',
    share: 'ចែករំលែក',
    fullscreen: 'ពេញអេក្រង់',
    exitFullscreen: 'ចេញពីពេញអេក្រង់',
    loadReportFirst: 'ផ្ទុករបាយការណ៍ជាមុនសិន',
    linkCopied: 'បានចម្លងតំណ!',
    markRead: 'សម្គាល់ថាបានអាន',
    notConfigured: 'មិនទាន់កំណត់',
    optional: '(ស្រេចចិត្ត)',
    imageFilesOnly: 'ឯកសាររូបភាពប៉ុណ្ណោះ',
    max5mb: 'អតិបរមា 5MB',
    taxRate: 'អត្រាពន្ធ (%)',
    taxPercent: 'ពន្ធ %',
    addr: 'អាសយដ្ឋាន',
    phone: 'ទូរស័ព្ទ',
    email: 'អ៊ីមែល',
    website: 'វេបសាយ',
    city: 'ទីក្រុង',
    country: 'ប្រទេស',
    on: 'បើក',
    off: 'បិទ',
    set: 'កំណត់',
    notSet: 'មិនទាន់កំណត់',
    enabled: 'បានដំណើរការ',
    disabled: 'បានបិទ',
    save2: 'រក្សាទុក',
    saved: 'បានរក្សាទុក',
    exported: 'បានរក្សា',
    reportExported: 'បានរក្សារបាយការណ៍',
    reportExportedSuccess: 'បានរក្សារបាយការណ៍ដោយជោគជ័យ',
    failedToLoad: 'បរាជ័យក្នុងការផ្ទុក',
    failedToSave: 'បរាជ័យក្នុងការរក្សាទុក',
    failedToUpdate: 'បរាជ័យក្នុងការធ្វើបច្ចុប្បន្នភាព',
    activate: 'ដំណើរការ',
    deactivate: 'បិទ',
    activated: 'បានដំណើរការ',
    deactivated: 'បានបិទ',
    yourBranch: 'សាខារបស់អ្នក',
    searchBranchCashier: 'ស្វែងរកសាខា អ្នកគិតថ្លៃ...',
    searchByNameCodeCity: 'ស្វែងរកតាមឈ្មោះ លេខកូដ ទីក្រុង...',
    enterName: 'បញ្ចូលឈ្មោះ',
    pleaseEnterName: 'សូមបញ្ចូលឈ្មោះ',
  },

  // ── Auth / Login ─────────────────────────────────────────────
  auth: {
    email: 'អ៊ីមែល',
    password: 'ពាក្យសម្ងាត់',
    signIn: 'ចូលប្រើ',
    signingIn: 'កំពុងចូល...',
    demoAccounts: 'គណនីសាកល្បង',
    welcomeBack: 'សូមស្វាគមន៍!',
    loginFailed: 'ការចូលបានបរាជ័យ',
  },

  // ── Navigation / Sidebar ─────────────────────────────────────
  nav: {
    main: 'មេ',
    sales: 'ការលក់',
    inventory: 'ស្តុក',
    finance: 'ហិរញ្ញវត្ថុ',
    system: 'ប្រព័ន្ធ',
    dashboard: 'ផ្ទាំងគ្រប់គ្រង',
    pos: 'POS',
    posSessions: 'វគ្គ POS',
    orders: 'បញ្ជាទិញ',
    invoices: 'វិក្កយបត្រ',
    customers: 'អតិថិជន',
    products: 'ផលិតផល',
    masterData: 'ទិន្នន័យមេ',
    stock: 'ស្តុក',
    purchaseOrders: 'បញ្ជាទិញ',
    stockTransfers: 'ផ្ទេរស្តុក',
    vendors: 'អ្នកផ្គត់ផ្គង់',
    commissions: 'កម្រៃជើងសារ',
    payments: 'ការទូទាត់',
    expenses: 'ចំណាយ',
    promotions: 'ការផ្សព្វផ្សាយ',
    currencies: 'រូបិយប័ណ្ណ',
    branches: 'សាខា',
    users: 'អ្នកប្រើប្រាស់',
    reports: 'របាយការណ៍',
    settings: 'ការកំណត់',
  },

  // ── Dashboard ────────────────────────────────────────────────
  dashboard: {
    title: 'ផ្ទាំងគ្រប់គ្រង',
    subtitle: 'ទិដ្ឋភាពទូទៅអាជីវកម្ម',
    revenue: 'ចំណូល',
    outstanding: 'នៅជំពាក់',
    customers: 'អតិថិជន',
    products: 'ផលិតផល',
    posToday: 'POS ថ្ងៃនេះ',
    paidInvoices: 'វិក្កយបត្របានបង់',
    unpaid: 'មិនទាន់បង់',
    lowStock: 'ស្តុកទាប',
    txns: 'ប្រតិបត្តិការ',
    recentOrders: 'ការបញ្ជាទិញថ្មីៗ',
    pendingCommissions: 'កម្រៃជើងសាររង់ចាំ',
    invoiceStatus: 'ស្ថានភាពវិក្កយបត្រ',
    none: 'គ្មាន',
  },

  // ── Orders ───────────────────────────────────────────────────
  orders: {
    invoiceCreatedStockDeducted: 'វិក្កយបត្រ {{num}} បានបង្កើត — ស្តុកត្រូវបានកាត់',
    insufficientStockOrder: 'ស្តុកមិនគ្រប់គ្រាន់ដើម្បីប្រែក្លាយបញ្ជាទិញទៅជាវិក្កយបត្រ',
    orderStockDeductNote: 'ស្តុកនឹងត្រូវបានកាត់ដោយស្វ័យប្រវត្តិពេលប្រែក្លាយជាវិក្កយបត្រ',
    title: 'បញ្ជាទិញលក់',
    newOrder: 'បញ្ជាទិញថ្មី',
    orderNumber: 'លេខបញ្ជាទិញ',
    orderDate: 'កាលបរិច្ឆេទបញ្ជាទិញ',
    orderLines: 'បន្ទាត់បញ្ជាទិញ',
    selectCustomer: '— ជ្រើសរើសអតិថិជន —',
    selectBranch: '— ជ្រើសរើសសាខា —',
    noOrders: 'រកមិនឃើញបញ្ជាទិញ',
    createOrder: 'បង្កើតបញ្ជាទិញ',
    saveChanges: 'រក្សាទុកការផ្លាស់ប្ដូរ',
    deleteOrder: 'លុបបញ្ជាទិញ',
    confirmDelete: 'លុបបញ្ជាទិញនេះ?',
    readyToInvoice: 'រួចរាល់ចេញវិក្កយបត្រ?',
    createInvoiceDesc: 'បង្កើតវិក្កយបត្រលក់ពីបញ្ជាទិញនេះ។ ស្ថានភាពនឹងប្ដូរទៅ "បានបញ្ចប់" ដោយស្វ័យប្រវត្តិ។',
    createInvoice: 'បង្កើតវិក្កយបត្រ',
    creating: 'កំពុងបង្កើត…',
    invoiceCreated: 'វិក្កយបត្រ {{num}} ត្រូវបានបង្កើត',
    orderCompleted: 'បញ្ជាទិញបានបញ្ចប់ · ទៅកាន់វិក្កយបត្រលក់',
    statusChanged: 'ស្ថានភាព → {{status}}',
    noItems: 'គ្មានបន្ទាត់ — ចុច បន្ថែម',
    noItemsMobile: 'គ្មានបន្ទាត់ — ចុច បន្ថែម',
    addItem: 'បន្ថែម',
    selectProduct: '— ជ្រើសរើសផលិតផល —',
    searchProduct: 'ស្វែងរកឈ្មោះ ឬ SKU...',
    noProductsFound: 'រកមិនឃើញផលិតផល',
    itemsCount: '{{n}} ធាតុ',
    itemsCountPlural: '{{n}} ធាតុ',
    changeStatus: 'ប្ដូរស្ថានភាព',
    invoiced: 'បានចេញវិក្កយបត្រ',
    orderCreated: 'បានបង្កើតបញ្ជាទិញ',
    orderUpdated: 'បានធ្វើបច្ចុប្បន្នភាពបញ្ជាទិញ',
    orderNeedsBranch: 'បញ្ជាទិញត្រូវការសាខាមុនចេញវិក្កយបត្រ',
    orderNotFound: 'រកមិនឃើញបញ្ជាទិញ',
    failedCreateInvoice: 'បរាជ័យក្នុងការបង្កើតវិក្កយបត្រ',
    failedLoadOrder: 'បរាជ័យក្នុងការផ្ទុកបញ្ជាទិញ',
    failedLoadOrders: 'បរាជ័យក្នុងការផ្ទុកបញ្ជីបញ្ជាទិញ',
    orderNotes: 'កំណត់ចំណាំបញ្ជាទិញ (ស្រេចចិត្ត)',
    deliveryAddress: 'អាសយដ្ឋានដឹក',
    orderAnalyticsReport: 'របាយការណ៍វិភាគបញ្ជាទិញ',
    orderCustomerDetail: 'លម្អិតបញ្ជាទិញ & អតិថិជន',
    allOrders: 'គ្រប់បញ្ជាទិញ',
    totalOrders: 'បញ្ជាទិញសរុប',
    totalRevenue: 'ចំណូលសរុប',
    searchOrders: 'ស្វែងរក # ការបញ្ជាទិញ អតិថិជន ផលិតផល…',
    failedPlaceOrder: 'បរាជ័យក្នុងការដាក់បញ្ជាទិញ',
    status: {
      draft: 'សំណាង',
      pending: 'រង់ចាំ',
      confirmed: 'បានបញ្ជាក់',
      processing: 'កំពុងដំណើរការ',
      shipped: 'បានដឹកជញ្ជូន',
      completed: 'បានបញ្ចប់',
      cancelled: 'បានបោះបង់',
    },
    columns: {
      num: 'លេខ',
      product: 'ផលិតផល',
      uom: 'ឯកតា',
      qty: 'បរិមាណ',
      unitPrice: 'តម្លៃឯកតា',
      amount: 'ចំនួន',
    },
  },

  // ── Invoices ─────────────────────────────────────────────────
  invoices: {
    title: 'វិក្កយបត្រលក់',
    newInvoice: 'វិក្កយបត្រថ្មី',
    invoiceNumber: 'លេខវិក្កយបត្រ',
    invoiceDate: 'កាលបរិច្ឆេទ',
    dueDate: 'ថ្ងៃផុតកំណត់',
    dueLabel: 'ផុតកំណត់',
    paymentTerms: 'លក្ខខណ្ឌទូទាត់',
    paymentTermsPlaceholder: 'ឧ. Net 30',
    lineItems: 'ធាតុបន្ទាត់',
    balance: 'សមតុល្យ',
    paid: 'បានបង់',
    recordPayment: 'កត់ត្រាការទូទាត់',
    balanceDue: 'សមតុល្យត្រូវបង់',
    settled: '✓ បានទូទាត់',
    totalInvoiced: 'ចំនួនរួម',
    collected: 'ប្រមូលបាន',
    outstanding: 'នៅជំពាក់',
    invoiced: 'ចំនួនចេញ',
    changeStatus: 'ប្ដូរស្ថានភាព',
    noInvoices: 'រកមិនឃើញវិក្កយបត្រ',
    customerRequired: 'សូមជ្រើសរើសអតិថិជន',
    addAtLeastOne: 'សូមបន្ថែមផលិតផលយ៉ាងហោចណាស់មួយ',
    noProductsFound: 'រកមិនឃើញផលិតផល',
    noStockAtBranch: 'គ្មានស្តុកនៅសាខានេះ',
    stockDeductFailed: 'ការកាត់ស្តុកបរាជ័យ',
    paymentRecorded: 'បានកត់ត្រាការទូទាត់',
    invoiceUpdated: 'វិក្កយបត្របានធ្វើបច្ចុប្បន្នភាព',
    invoiceCreated: 'វិក្កយបត្របានបង្កើត',
    failedToLoad: 'បរាជ័យក្នុងការផ្ទុក',
    failedToSave: 'បរាជ័យក្នុងការរក្សាទុក',
    enterValidAmount: 'សូមបញ្ចូលចំនួនត្រឹមត្រូវ',
    customerName: 'ឈ្មោះអតិថិជន',
    totalAmountDue: 'ចំនួនសរុបត្រូវបង់',
    createdBy: 'បង្កើតដោយ',
    paymentReceived: 'ទទួលបានការទូទាត់',
    paymentHistory: 'ប្រវត្តិទូទាត់',
    notesPaymentTerms: 'កំណត់ចំណាំ / លក្ខខណ្ឌការទូទាត់',
    internalNotes: 'កំណត់ចំណាំផ្ទៃក្នុង…',
    companyName: 'ឈ្មោះក្រុមហ៊ុន',
    stockFromBranch: 'ស្តុកពីសាខា',
    searchInvoice: 'លេខវិក្កយបត្រ ឬ អតិថិជន...',
    yourBranch: 'សាខារបស់អ្នក',
    order: 'បញ្ជាទិញ',
    totalInvoices: 'វិក្កយបត្រសរុប',
    disc: 'បញ្ចុះ',
    out: 'នៅជំពាក់',
    columns: {
      num: 'លេខ',
      product: 'ផលិតផល',
      uom: 'UoM',
      qty: 'បរិមាណ',
      unitPrice: 'តម្លៃឯកតា',
      discount: 'បញ្ចុះ',
      amount: 'ចំនួន',
      price: 'តម្លៃ',
    },
    status: {
      draft: 'សំណាង',
      sent: 'បានផ្ញើ',
      paid: 'បានបង់',
      partial: 'មួយផ្នែក',
      overdue: 'ហួសកំណត់',
      cancelled: 'បានបោះបង់',
    },
    pay: {
      title: 'កត់ត្រាការទូទាត់ — {{num}}',
      amount: 'ចំនួន *',
      method: 'វិធីទូទាត់',
      reference: 'លេខយោង / លេខប្រតិបត្តិការ',
      refPlaceholder: 'ឧ. TXN-12345',
    },
  },

  // ── POS ──────────────────────────────────────────────────────
  pos: {
    openSession: 'បើកវគ្គ POS',
    openRegister: 'បើកម៉ាស៊ីនទទួលប្រាក់',
    openingBalance: 'សមតុល្យបើក (ដុល្លារ)',
    closeSession: 'បិទវគ្គ POS',
    closeRegister: 'បិទម៉ាស៊ីន',
    closingBalance: 'សមតុល្យបិទ (ដុល្លារ)',
    closePrompt: 'រាប់ប្រាក់ក្នុងថតហើយបញ្ចូលសមតុល្យបិទ។',
    forceClose: 'បិទបង្ខំ',
    registerOpen: 'ម៉ាស៊ីនបើករួច',
    cashRegisterClosed: 'ម៉ាស៊ីនគិតប្រាក់បិទ',
    noPermissionOpen: 'គ្មានសិទ្ធបើកវគ្គ',
    noPermissionClose: 'គ្មានសិទ្ធបិទវគ្គនេះ',
    sessionClosedSuccess: 'វគ្គបានបិទដោយជោគជ័យ',
    sessionsExported: 'វគ្គបានរក្សា',
    products: 'ផលិតផល',
    cart: 'កន្ត្រក',
    orders: 'ការបញ្ជាទិញ',
    cartItems: '({{n}} ធាតុ)',
    clearCart: 'សម្អាត',
    outOfStock: 'អស់ស្តុក!',
    onlyInStock: 'នៅសល់ {{n}} ប៉ុណ្ណោះ',
    addedToCart: 'បានបន្ថែម {{name}}',
    charge: 'គិតថ្លៃ {{amount}}',
    payment: '💳 ការទូទាត់',
    totalDue: 'ចំនួនត្រូវបង់',
    paymentMethods: 'វិធីទូទាត់',
    change: 'អាប់',
    shortBy: '⚠️ ខ្វះ {{amount}}',
    insufficientPayment: 'ការទូទាត់មិនគ្រប់',
    completeSale: 'បញ្ចប់ការលក់',
    saleCompleted: '✅ ការលក់បានបញ្ចប់!',
    saleFailed: 'ការលក់បានបរាជ័យ',
    walkIn: 'អតិថិជនទូទៅ',
    discount: 'បញ្ចុះតម្លៃ:',
    fixed: '$ ថេរ',
    percent: '% ភាគរយ',
    searchProducts: 'ស្វែងរកឈ្មោះ SKU បាកូដ...',
    noProductsFound: 'រកមិនឃើញផលិតផល',
    void: 'បោះបង់',
    voiding: 'កំពុងបោះបង់…',
    voidTransaction: 'បោះបង់ប្រតិបត្តិការ',
    voidConfirm: 'បញ្ជាក់ការបោះបង់?',
    voidDesc: 'ប្រតិបត្តិការនេះនឹងត្រូវបានបោះបង់ ហើយស្តុកទាំងអស់នឹងត្រូវស្តារ។ មិនអាចទប់ស្កាត់បានទេ។',
    voided: 'ប្រតិបត្តិការបានបោះបង់',
    voidedDesc: 'ស្តុករបស់ធាតុទាំងអស់ត្រូវបានស្តារ។',
    voidSuccess: '{{num}} បានបោះបង់ — ស្តុកបានស្តារ',
    voidFailed: 'ការបោះបង់បានបរាជ័យ',
    transactionNumber: 'លេខប្រតិបត្តិការ',
    paymentBreakdown: 'ការបំបែកការទូទាត់',
    lineItems: 'ធាតុបន្ទាត់',
    noSession: 'គ្មានវគ្គបើក',
    receipt: 'វិក្កយបត្រ',
    reprintReceipt: 'បោះពុម្ពវិក្កយបត្រម្ដងទៀត',
    cashSales: 'ការលក់សាច់ប្រាក់',
    cardSales: 'ការលក់ប័ណ្ណ',
    openingBal: 'សមតុល្យបើក',
    closingBal: 'សមតុល្យបិទ',
    expected: 'រំពឹងទុក',
    actualClosing: 'ការបិទពិតប្រាកដ',
    difference: 'ភាពខុស',
    short: 'ខ្វះ',
    over: 'លើស',
    openingTime: 'ពេលបើក',
    closingTime: 'ពេលបិទ',
    cashBalance: 'សមតុល្យសាច់ប្រាក់',
    resetToExpected: 'កំណត់ទៅតម្លៃរំពឹង',
  },

  // ── POS Sessions ─────────────────────────────────────────────
  posSessions: {
    title: 'វគ្គ POS & របាយការណ៍',
    posReports: 'របាយការណ៍ POS',
    sessionList: 'បញ្ជីវគ្គ',
    branchReports: 'របាយការណ៍សាខា',
    ordersReport: 'របាយការណ៍ការបញ្ជាទិញ',
    customersReport: 'របាយការណ៍អតិថិជន',
    byOrder: 'តាមការបញ្ជាទិញ',
    byCustomer: 'តាមអតិថិជន',
    byHour: 'តាមម៉ោង',
    detail: 'លម្អិត',
    open: 'បើក',
    closed: 'បិទ',
    closing: 'កំពុងបិទ',
    stillOpen: 'នៅបើក',
    duration: 'រយៈពេល',
    totalSales: 'ការលក់សរុប',
    transactions: 'ប្រតិបត្តិការ',
    openSessions: 'វគ្គបើក',
    closedSessions: 'វគ្គបិទ',
    allSessions: 'គ្រប់វគ្គ',
    totalSessions: 'វគ្គសរុប',
    avgPerSession: 'មធ្យម / វគ្គ',
    avgSession: 'ការលក់មធ្យម/វគ្គ',
    noSessions: 'រកមិនឃើញវគ្គ',
    failedLoadSessions: 'បរាជ័យក្នុងការផ្ទុកវគ្គ',
    runReport: 'ដំណើរការរបាយការណ៍',
    dateFrom: 'ចាប់ពី',
    dateTo: 'រហូតដល់',
    today: 'ថ្ងៃនេះ',
    yesterday: 'ម្សិលមិញ',
    thisWeek: 'សប្ដាហ៍នេះ',
    thisMonth: 'ខែនេះ',
    last30: '30 ថ្ងៃចុងក្រោយ',
    allTime: 'ទាំងអស់',
    branchPerformance: 'ចំណាត់ថ្នាក់ការអនុវត្តសាខា',
    viewDetails: 'មើលលម្អិត',
    revenue: 'ចំណូល',
    avgTxn: 'ប្រតិបត្តិការមធ្យម',
    avgTransaction: 'ប្រតិបត្តិការមធ្យម',
    pctOfTotal: '% នៃសរុប',
    topCashiers: 'អ្នកគិតថ្លៃខ្ពស់បំផុត',
    cashiers: 'អ្នកគិតថ្លៃ',
    topProducts: 'ផលិតផលខ្ពស់បំផុត',
    paymentMethods: 'វិធីទូទាត់',
    dailySales: 'និន្នាការការលក់ប្រចាំថ្ងៃ',
    dailyTrend: 'និន្នាការប្រចាំថ្ងៃ',
    dailyComparison: 'ការប្រៀបធៀបការលក់ប្រចាំថ្ងៃ — គ្រប់សាខា',
    branchSummary: 'តារាងសង្ខេបសាខា',
    groupBy: 'ក្រុមតាម',
    hour: 'ម៉ោង',
    hourly: 'ប្រចាំម៉ោង',
    avgHourly: 'មធ្យមប្រចាំម៉ោង',
    day: 'ថ្ងៃ',
    week: 'សប្ដាហ៍',
    month: 'ខែ',
    sortBy: 'តម្រៀបតាម',
    byRevenue: 'ចំណូលសរុប',
    byFrequency: 'ភាពញឹកញាប់ទស្សនៈ',
    byAvgOrder: 'តម្លៃបញ្ជាទិញមធ្យម',
    byRecency: 'ថ្មីបំផុត',
    registered: 'ចុះឈ្មោះ',
    walkIn: 'ប្រតិបត្តិការទូទៅ',
    walkInOrders: 'ការបញ្ជាទិញទូទៅ',
    repeatCustomers: 'អតិថិជនប្រចាំ',
    customerRevenue: 'ចំណូលពីអតិថិជន',
    avgPerCustomer: 'មធ្យម / អតிថិជន',
    walkInRevenue: 'ចំណូលពីអតិថិជនទូទៅ',
    top10Customers: 'អតិថិជន 10 ខ្ពស់បំផុតតាមចំណូល',
    revenueSplit: 'ការបែងចែកចំណូល',
    customerTiers: 'កម្រិតអតិថិជន',
    tierGold: 'មាស',
    tierSilver: 'ប្រាក់',
    tierBronze: 'សំរិទ្ធ',
    firstVisit: 'ការទស្សនៈដំបូង',
    lastVisit: 'ការទស្សនៈចុងក្រោយ',
    lastPurchase: 'ការទិញចុងក្រោយ',
    daysSinceLast: 'ថ្ងៃចាប់ពីចុងក្រោយ',
    visitDays: 'ថ្ងៃទស្សនៈ',
    totalDiscount: 'បញ្ចុះតម្លៃសរុប',
    totalDiscounts: 'បញ្ចុះតម្លៃសរុប',
    branches: 'សាខា',
    favProducts: 'ផលិតផលចូលចិត្ត',
    allCustomers: 'អតិថិជនទាំងអស់',
    fullSessionSummary: 'សង្ខេបវគ្គពេញ ការលក់ ការសង និងភាពខុស',
    sessionId: 'លេខសម្គាល់វគ្គ',
    opened: 'បានបើក',
    searchSession: 'ស្វែងរក # ប្រតិបត្តិការ អតិថិជន…',
    cashierSearch: 'ស្វែងរក # ប្រតិបត្តិការ អ្នកគិតថ្លៃ...',
    peakHour: 'ម៉ោងខ្ពស់',
    peakHours: 'ម៉ោងភ្លឺ',
    peakSales: 'ការលក់ខ្ពស់',
    bestDay: 'ថ្ងៃល្អបំផុត',
    dayOfWeek: 'ថ្ងៃក្នុងសប្ដាហ៍',
    totalDays: 'ថ្ងៃសរុប',
    totalHours: 'ម៉ោងសរុប',
    avgDailySales: 'ការលក់មធ្យមប្រចាំថ្ងៃ',
    avgOrderValue: 'តម្លៃការបញ្ជាទិញមធ្យម',
    avgOrder: 'ការបញ្ជាទិញមធ្យម',
    avgPrice: 'តម្លៃមធ្យម',
    avgProductRevenue: 'ចំណូលមធ្យមផលិតផល',
    avgOrders: 'ការបញ្ជាទិញមធ្យម',
    avgCustomerValue: 'តម្លៃអតិថិជនមធ្យម',
    uniqueCustomers: 'អតிថិជនផ្តាច់មុខ',
    newCustomers: 'អតិថិជនថ្មី',
    vipCustomers: 'អតិថិជន VIP',
    atRisk: 'ហានិភ័យ',
    atRiskCustomers: 'អតិថិជនប្រឈមហានិភ័យ',
    vipPlatinum: 'VIP/Platinum',
    segment: 'ផ្នែក',
    frequency: 'ភាពញឹកញាប់',
    frequencyPerDay: 'ភាពញឹកញាប់ (ការបញ្ជាទិញ/ថ្ងៃ)',
    lifetimeValue: 'តម្លៃអ្នកប្រើ',
    firstOrder: 'ការបញ្ជាទិញដំបូង',
    lastOrder: 'ការបញ្ជាទិញចុងក្រោយ',
    customerId: 'លេខអតិថិជន',
    customerPhone: 'ទូរស័ព្ទអតិថិជន',
    totalSpent: 'ចំណាយសរុប',
    searchCustomerPhone: 'ស្វែងរក អតិថិជន ទូរស័ព្ទ…',
    searchOrderProduct: 'ស្វែងរក # ការបញ្ជាទិញ ផលிតផល…',
    productsSold: 'ផលិតផលបានលក់',
    unitsSold: 'ឯកតាបានលក់',
    qtySold: 'បរិមាណបានលក់',
    topMethod: 'វិធីខ្ពស់',
    topPaymentMethod: 'វិធីទូទាត់ខ្ពស់',
    failedLoadPaymentMethods: 'បរាជ័យក្នុងការផ្ទុកវិធីទូទាត់',
    failedLoadCustomerOrders: 'បរាជ័យក្នុងការផ្ទុកបញ្ជាទិញអតិថិជន',
    failedLoadCustomersReport: 'បរាជ័យក្នុងការផ្ទុករបាយការណ៍អតិថិជន',
    failedLoadOrdersReport: 'បរាជ័យក្នុងការផ្ទុករបាយការណ៍ការបញ្ជាទិញ',
    failedLoadDailySales: 'បរាជ័យក្នុងការផ្ទុករបាយការណ៍លក់ប្រចាំថ្ងៃ',
    failedLoadHourly: 'បរាជ័យក្នុងការផ្ទុករបាយការណ៍វិភាគប្រចាំម៉ោង',
    failedLoadProducts: 'បរាជ័យក្នុងការផ្ទុករបាយការណ៍ផលិតផល',
    customerReport: 'អតិថិជន — ឥរិយាបថ ការបែងចែក និងតម្លៃ',
    orderAnalytics: 'ការវិភាគប្រតិបត្តិការ ការទូទាត់ អតិថិជន',
    revenueBar: 'ចំណូល (បន្ទះ)',
    overview: 'ទិដ្ឋភាពទូទៅ',
    totalPosSales: 'ការលក់ POS សរុប',
    refunds: 'ការសង',
    preparing: 'កំពុងរៀបចំ',
    on_the_way: 'កំពុងដឹក',
    collectedUsd: 'ប្រមូលបាន (ដុល្លារ)',
    collectedKhr: 'ប្រមូលបាន (រៀល)',
  },

  // ── Customers ────────────────────────────────────────────────
  customers: {
    title: 'អតិថិជន',
    newCustomer: 'អតិថិជនថ្មី',
    name: 'ឈ្មោះ',
    fullName: 'ឈ្មោះពេញ *',
    email: 'អ៊ីមែល',
    phone: 'ទូរស័ព្ទ',
    phoneNumber: 'លេខទូរស័ព្ទ',
    address: 'អាសយដ្ឋាន',
    city: 'ទីក្រុង',
    country: 'ប្រទេស',
    type: 'ប្រភេទ',
    customerType: 'ប្រភេទអតិថិជន',
    group: 'ក្រុម',
    customerGroup: 'ក្រុមអតិថិជន',
    creditLimit: 'ដែនកំណត់ឥណទាន',
    loyaltyPoints: 'ពិន្ទុភក្ដីភាព',
    discountPercent: 'ភាគរយបញ្ចុះតម្លៃ',
    birthday: 'ថ្ងៃខួបកំណើត',
    isBlacklisted: 'បញ្ជីខ្មៅ',
    isActive: 'សកម្ម',
    business: 'អាជីវកម្ម',
    individual: 'បុគ្គល',
    regular: 'ធម្មតា',
    vip: 'VIP',
    wholesale: 'លក់ដុំ',
    noCustomers: 'រកមិនឃើញអតិថិជន',
    searchPlaceholder: 'ស្វែងរកអតិថិជន...',
    editCustomer: 'កែសម្រួលអតិថិជន',
    deleteCustomer: 'លុបអតិថិជន',
    deleteConfirm: 'លុបអតិថិជននេះ?',
    activate: 'ដំណើរការ',
    deactivate: 'បិទ',
    activated: 'បានដំណើរការ',
    deactivated: 'បានបិទ',
    blacklist: 'ដាក់បញ្ជីខ្មៅ',
    unblock: 'ដោះចេញ',
    blacklisted: 'ស្ថិតក្នុងបញ្ជីខ្មៅ',
    removedFromBlacklist: 'បានដកចេញពីបញ្ជីខ្មៅ',
    balance: 'សមតុល្យ',
    points: 'ពិន្ទុ',
    yourBranch: 'សាខារបស់អ្នក',
    nameRequired: 'ទាមទារឈ្មោះ',
    created: 'បានបង្កើតអតិថិជន',
    updated: 'បានធ្វើបច្ចុប្បន្នភាពអតិថិជន',
    deleted: 'បានលុបអតិថិជន',
    discountGroupDesc: 'ភាគរយបញ្ចុះតម្លៃសម្រាប់ក្រុមនេះ',
    briefDescription: 'ការពិពណ៌នាខ្លី',
    totalCustomers: 'អតិថិជនសរុប',
    activeCustomers: 'អតិថិជនសកម្ម',
    activeBranches: 'សាខាសកម្ម',
    columns: {
      customer: 'អតិថិជន',
      type: 'ប្រភេទ',
      phone: 'ទូរស័ព្ទ',
      group: 'ក្រុម',
      branch: 'សាខា',
      creditLimit: 'ដែនកំណត់ឥណទាន',
      balance: 'សមតុល្យ',
      points: 'ពិន្ទុ',
      status: 'ស្ថានភាព',
      actions: 'សកម្មភាព',
    },
  },

  // ── Products ─────────────────────────────────────────────────
  products: {
    title: 'ផលិតផល',
    newProduct: 'ផលិតផលថ្មី',
    addProduct: 'បន្ថែមផលិតផល',
    editProduct: 'កែសម្រួលផលិតផល',
    deleteProduct: 'លុបផលិតផល',
    sku: 'SKU',
    skuNameRequired: 'ទាមទារ SKU និងឈ្មោះ',
    nameEn: 'ឈ្មោះ (EN)',
    nameKh: 'ឈ្មោះ (KH)',
    category: 'ប្រភេទ',
    brand: 'ម៉ាក',
    brandName: 'ឈ្មោះម៉ាក',
    brandLogo: 'រូបម៉ាក',
    costPrice: 'តម្លៃដើម',
    salePrice: 'តម្លៃលក់',
    baseSalePrice: 'តម្លៃលក់មូលដ្ឋាន',
    wholesalePrice: 'តម្លៃដុំ',
    wholesale: 'ដុំ',
    minPrice: 'តម្លៃអប្បបរមា',
    stock: 'ស្តុក',
    lowStock: 'ស្តុកទាប',
    outOfStock: 'អស់ស្តុក',
    reorderLevel: 'ចំណុចបញ្ជាទិញ',
    barcode: 'បាកូដ',
    isActive: 'សកម្ម',
    trackStock: 'តាមដានស្តុក',
    allowNegativeStock: 'អនុញ្ញាតស្តុកអវិជ្ជមាន',
    uom: 'ឯកតារង្វាស់',
    selectUom: 'ជ្រើសរើស UoM',
    baseUnit: 'ឯកតាមូលដ្ឋាន',
    conversionFactor: 'ចំណែករូបាន',
    factorDesc: 'ចំណែក (ចំនួនឯកតាមូលដ្ឋាន)',
    pricePerThisUnit: 'តម្លៃ/ឯកតានេះ',
    commission: 'កម្រៃជើងសារ',
    commissionPercent: 'កម្រៃ %',
    pricePerUnit: 'តម្លៃ/ឯកតា',
    taxPercent: 'ពន្ធ %',
    margin: 'ប្រាក់ចំណេញ',
    description: 'ការពិពណ៌នា',
    images: 'រូបភាព',
    imageUrl: 'URL រូបភាព (ឬបញ្ចូលខាងលើ)',
    editUrl: 'កែ URL',
    newUrl: 'URL ថ្មី...',
    setPrimary: 'កំណត់ជាចម្បង',
    weightKg: 'ទម្ងន់ (គីឡូក្រាម)',
    safetyStock: 'ស្តុកសុវត្ថិភាព',
    batchLotTracking: 'តាមដានបាច់',
    serialTracking: 'តាមដានលេខស៊េរី',
    expiryTracking: 'តាមដានផុតកំណត់',
    serialNumber: 'លេខស៊េរី',
    batchNumber: 'លេខបាច់',
    noProducts: 'រកមិនឃើញផលិតផល',
    searchPlaceholder: 'ស្វែងរកឈ្មោះ SKU បាកូដ...',
    deleteConfirm: 'លុបផលិតផលនេះ?',
    piece: 'ដំណក់',
    urlRequired: 'ទាមទារ URL',
    uomPriceFailed: 'បរាជ័យក្នុងការរក្សាទុកតម្លៃ UoM',
    uploadedAdded: 'បានបញ្ចូល និងបន្ថែម',
    totalProducts: 'ផលិតផលសរុប',
    columns: {
      img: 'រូប',
      sku: 'SKU',
      product: 'ផលិតផល',
      category: 'ប្រភេទ',
      brand: 'ម៉ាក',
      cost: 'ដើម',
      sale: 'លក់',
      ws: 'ដុំ',
      stock: 'ស្តុក',
      uom: 'UoM',
      commission: 'កម្រៃ',
      track: 'តាមដាន',
      status: 'ស្ថានភាព',
      barcode: 'បាកូដ',
      margin: 'ចំណេញ',
    },
  },

  // ── Inventory / Stock ─────────────────────────────────────────
  inventory: {
    title: 'ការគ្រប់គ្រងស្តុក',
    subtitle: '{{n}} កំណត់ត្រាស្តុក',
    tabs: {
      stock:     'កម្រិតស្តុក',
      reports:   'របាយការណ៍ស្តុក និង UoM',
      movements: 'ប្រវត្តិចលនា',
    },
    stockIn:  'ស្តុកចូល',
    stockOut: 'ស្តុកចេញ',
    allBranches:  'គ្រប់សាខា',
    allProducts:  'គ្រប់ផលិតផល',
    lowStockOnly: 'ស្តុកទាបប៉ុណ្ណោះ',
    fromDate:     'ចាប់ពីថ្ងៃ',
    toDate:       'រហូតដល់ថ្ងៃ',
    col: {
      product:   'ផលិតផល',
      branch:    'សាខា',
      location:  'ទីតាំង',
      onHand:    'នៅក្នុងដៃ',
      reserved:  'បានរក្សាទុក',
      available: 'អាចប្រើបាន',
      reorder:   'ចំណាត់ការ',
      unitCost:  'តម្លៃក្នុងមួយ',
      value:     'តម្លៃ',
      batch:     'ដំណាំ',
      expiry:    'ហួតកំណត់',
      actions:   'សកម្មភាព',
      sku:       'SKU',
      type:      'ប្រភេទ',
      qty:       'បរិមាណ',
      date:      'កាលបរិច្ឆេទ',
      reference: 'លេខយោង',
      notes:     'កំណត់ចំណាំ',
    },
    in:  'ចូល',
    out: 'ចេញ',
    stockInTitle:   'ស្តុកចូល — ទទួលទំនិញ',
    addingStock:    'កំពុងបន្ថែមស្តុកទៅស្តុក',
    receiveStock:   'ទទួលស្តុក',
    productRequired: 'ផលិតផល *',
    branchRequired:  'សាខា *',
    unitCostUsd:    'តម្លៃក្នុងមួយ ($)',
    referenceType:  'ប្រភេទលេខយោង',
    batchNumber:    'លេខដំណាំ',
    serialNumber:   'លេខស៊េរី',
    expiryDate:     'ថ្ងៃផុតកំណត់',
    notesPlaceholder: 'មូលហេតុ / លេខយោង PO...',
    totalValue:     'តម្លៃសរុប',
    refTypes: {
      purchase:    'លំដាប់ទិញ',
      return:      'ការត្រឡប់ពីអតិថិជន',
      transfer:    'ផ្ទេរចូល',
      adjustment:  'ការកែតម្រូវ',
      manual:      'ការបញ្ចូលដោយដៃ',
    },
    stockOutTitle:   'ស្តុកចេញ — ចេញទំនិញ',
    removingStock:   'កំពុងដកស្តុកចេញ',
    issueStock:      'ចេញស្តុក',
    reasonLabel:     'មូលហេតុ',
    reasonPlaceholder: 'មូលហេតុ / លេខយោង SO...',
    issueTypes: {
      sale:          'ការលក់ / ការដឹកជញ្ជូន',
      damage:        'ខូចខាត / ផុតកំណត់',
      transfer:      'ផ្ទេរចេញ',
      return_vendor: 'ត្រឡប់ទៅអ្នកផ្គត់ផ្គង់',
      manual:        'ការលុបចោលដោយដៃ',
    },
    selectUom:         'ឯកតានៃការវាស់',
    baseUnit:          'ឯកតាមូលដ្ឋាន',
    baseUnitLabel:     '(ឯកតាមូលដ្ឋាន)',
    uomPillFactor:     '×{{n}}',
    willAdd:           'នឹងបន្ថែម',
    willRemove:        'នឹងដក',
    toBaseStock:       'ទៅស្តុកមូលដ្ឋាន',
    fromBaseStock:     'ចេញពីស្តុកមូលដ្ឋាន',
    receiving:         'ទទួល',
    issuing:           'ចេញ',
    quantityIn:        'បរិមាណ (ជា {{uom}})',
    quantityLabel:     'បរិមាណ *',
    uomConversionNote: 'ទទួល {{qty}} {{uom}} = នឹងបន្ថែម {{base}} {{baseUnit}} ទៅស្តុក',
    uomIssuanceNote:   'ចេញ {{qty}} {{uom}} = នឹងដក {{base}} {{baseUnit}} ចេញពីស្តុក',
    reportTabs: {
      summary:    'សង្ខេប',
      byuom:      'តាមឯកតា',
      valuation:  'ការវាយតម្លៃ',
      lowstock:   'ស្តុកទាប / អស់ស្តុក',
    },
    kpi: {
      totalSkus:    'SKU សរុប',
      stockRecords: 'កំណត់ត្រាស្តុក',
      costValue:    'តម្លៃដើម',
      saleValue:    'តម្លៃលក់',
      lowStock:     'ស្តុកទាប',
      outOfStock:   'អស់ស្តុក',
    },
    moveTypes: { all:'ទាំងអស់', in:'ចូល', out:'ចេញ', adjustment:'កែតម្រូវ', transfer_in:'ផ្ទេរចូល', transfer_out:'ផ្ទេរចេញ', return:'ត្រឡប់', damage:'ខូចខាត' },
    clearFilters: 'សម្អាត',
    loadingInventory: 'កំពុងផ្ទុកស្តុក...',
    productBranchQtyRequired: 'ទាមទារផលិតផល សាខា និងបរិមាណ',
    stockInSuccess:  'ស្តុកចូល: +{{qty}} ឯកតាមូលដ្ឋាន',
    stockOutSuccess: 'ស្តុកចេញ: -{{qty}} ឯកតាមូលដ្ឋាន',
    stockInFailed:   'បរាជ័យក្នុងការទទួលស្តុក',
    stockOutFailed:  'បរាជ័យក្នុងការចេញស្តុក',
    stockRestored:       'ស្តុកត្រូវបានស្ដារ',
    stockRestoredVoid:   'ស្តុកត្រូវបានស្ដារ — ប្រតិបត្តិការត្រូវបានលុបចោល',
    stockRestoredCancel: 'ស្តុកត្រូវបានស្ដារ — វិក្កយបត្រត្រូវបានបោះបង់',
    stockRestoredDelete: 'ស្តុកត្រូវបានស្ដារ — វិក្កយបត្រត្រូវបានលុប',
    stockRestoredEdit:   'ស្តុកត្រូវបានស្ដារ — ទំនិញវិក្កយបត្រត្រូវបានកែ',
    voidRestoreNote:     'លុបចោល {{num}} — UoM ×{{factor}} (ចំនួន {{qty}}, ស្ដារ {{base}} ឯកតាមូលដ្ឋាន)',
    alreadyVoided:       'ប្រតិបត្តិការបានលុបចោលរួចហើយ',
    cantDeletePaid:      'មិនអាចលុបវិក្កយបត្រដែលមានការទូទាត់',
    cantEditStatus:      'មិនអាចកែចនាមួយដែលមានស្ថានភាព: {{status}}',
    uomConversion:       'ការបំលែងUoM ×{{factor}} (លក់ {{qty}}, កាត់ {{base}} ឯកតាមូលដ្ឋាន)',
    baseUnitDeduction:   'ការកាត់ឯកតាមូលដ្ឋាន',
    boxExample:          'ឧ. ១ ប្រអប់ = ២៤ ដប',
  },

  // ── Vendors ───────────────────────────────────────────────────
  vendors: {
    title: 'អ្នកផ្គត់ផ្គង់',
    newVendor: 'អ្នកផ្គត់ផ្គង់ថ្មី',
    editVendor: 'កែសម្រួលអ្នកផ្គត់ផ្គង់',
    deleteVendor: 'លុបអ្នកផ្គត់ផ្គង់',
    deleteConfirm: 'លុបជាអចិន្ត្រៃយ៍?',
    companyName: 'ឈ្មោះក្រុមហ៊ុន',
    contactPerson: 'អ្នកទំនាក់ទំនង',
    email: 'អ៊ីមែល',
    phone: 'ទូរស័ព្ទ',
    address: 'អាសយដ្ឋាន',
    city: 'ទីក្រុង',
    country: 'ប្រទេស',
    taxId: 'លេខសម្គាល់ពន្ធ',
    rating: 'ការវាយតម្លៃ (0-5)',
    leadTime: 'រយៈពេលដឹក (ថ្ងៃ)',
    leadTimeDays: 'រយៈពេលដឹក',
    paymentTerms: 'លក្ខខណ្ឌការទូទាត់',
    notes: 'កំណត់ចំណាំ',
    isActive: 'សកម្ម',
    noVendors: 'រកមិនឃើញអ្នកផ្គត់ផ្គង់',
    searchPlaceholder: 'ស្វែងរកអ្នកផ្គត់ផ្គង់...',
    nameRequired: 'ទាមទារឈ្មោះ',
    days: 'ថ្ងៃ',
    noPermission: 'អ្នកមិនមានសិទ្ធ',
    columns: {
      vendor: 'អ្នកផ្គត់ផ្គង់',
      email: 'អ៊ីមែល',
      phone: 'ទូរស័ព្ទ',
      country: 'ប្រទេស',
      rating: 'ការវាយតម្លៃ',
      leadTime: 'រយៈពេលដឹក',
      terms: 'លក្ខខណ្ឌ',
      status: 'ស្ថានភាព',
    },
  },

  // ── Commissions ───────────────────────────────────────────────
  commissions: {
    title: 'កម្រៃជើងសារ',
    subtitle: 'គ្រប់គ្រង អនុម័ត និងវិភាគកំណត់ត្រាកម្រៃជើងសារ',
    list: 'បញ្ជីកម្រៃជើងសារ',
    rules: 'វិធាន',
    reports: 'របាយការណ៍',
    commissionId: 'លេខសម្គាល់កម្រៃ',
    newRule: 'វិធានថ្មី',
    newRuleBtn: '+ វិធានថ្មី',
    createRule: 'បង្កើតវិធាន',
    editRule: 'កែសម្រួលវិធាន',
    ruleCreated: 'បានបង្កើតវិធាន',
    ruleUpdated: 'បានធ្វើបច្ចុប្បន្នភាពវិធាន',
    ruleDeleted: 'បានលុបវិធាន',
    commissionUpdated: 'បានធ្វើបច្ចុប្បន្នភាពកម្រៃ',
    noCommissions: 'រកមិនឃើញកម្រៃជើងសារ',
    noProductLinked: 'គ្មានទិន្នន័យកម្រៃដែលភ្ជាប់ជាមួយផលិតផល',
    searchPlaceholder: 'ស្វែងរកប្រភេទ វិក្កយបត្រ អ្នកប្រើ សាខា...',
    ratePercent: 'អត្រា (%) *',
    rateLabel: 'អត្រា (%)',
    baseAmount: 'ចំនួនមូលដ្ឋាន',
    base: 'មូលដ្ឋាន',
    totalBase: 'ចំនួនមូលដ្ឋានសរុប',
    totalCommission: 'កម្រៃជើងសារសរុប',
    totalRecords: 'កំណត់ត្រាសរុប',
    paidOut: 'បានបង់',
    paidAt: 'បានបង់នៅ',
    byProduct: 'តាមផលិតផល',
    byType: 'តាមប្រភេទ',
    byUser: 'តាមអ្នកប្រើ',
    optionalNotes: 'កំណត់ចំណាំ (ស្រេចចិត្ត)…',
    enterValidAmount: 'សូមបញ្ចូលចំនួនត្រឹមត្រូវ',
    validRateRequired: 'ទាមទារអត្រាត្រឹមត្រូវ',
    nameRequired: 'ទាមទារឈ្មោះ',
    exported: 'បានរក្សាទុក',
    failedLoad: 'បរាជ័យក្នុងការផ្ទុកកម្រៃ',
    failedReport: 'បរាជ័យក្នុងការផ្ទុករបាយការណ៍',
    failedUpdate: 'បរាជ័យក្នុងការធ្វើបច្ចុប្បន្នភាព',
    noPermission: '🔒 អ្នកមិនមានសិទ្ធិមើលកម្រៃជើងសារ។',
    package: 'កញ្ចប់',
    priority: 'អាទិភាព',
    name: 'ឈ្មោះ',
    ruleActive: 'វិធានសកម្ម',
    appliesTo: 'អនុវត្តលើ',
    earned: 'បានរកបាន',
    commissionRecord: 'កំណត់ត្រាកម្រៃ',
    commissionRecords: 'កំណត់ត្រា',
    breakdownByStatus: 'ចំណែកតាមស្ថានភាព',
    records: 'កំណត់ត្រា',
    loadingReport: 'កំពុងផ្ទុករបាយការណ៍…',
    noData: 'គ្មានទិន្នន័យ',
    changeStatus: 'ប្ដូរស្ថានភាពទៅ',
    // Bulk actions (added v17)
    selectAll: 'ជ្រើសទាំងអស់',
    selected: '{{n}} បានជ្រើស',
    records: '{{n}} កំណត់ត្រា',
    approveSelected: 'អនុម័តដែលបានជ្រើស',
    markPaid: 'សម្គាល់ថាបានបង់',
    cancelSelected: 'បោះបង់',
    bulkApproved: '{{n}} កម្រៃ → បានអនុម័ត',
    bulkPaid: '{{n}} កម្រៃ → បានបង់',
    bulkCancelled: '{{n}} កម្រៃ → បានបោះបង់',
    bulkFailed: 'សកម្មភាពចំនួនច្រើនបរាជ័យ',
    clearSelection: 'សម្អាត',
    addOptionalNote: 'បន្ថែមកំណត់ចំណាំ (ស្រេចចិត្ត)។',
    current: 'បច្ចុប្បន្ន',
    statusChanged: 'ស្ថានភាព → {{status}}',
    editCommission: 'កែកម្រៃ #{{id}}',
    amountUsd: 'ចំនួន ($) *',
    type: 'ប្រភេទ',
    user: 'អ្នកប្រើ',
    invoice: 'វិក្កយបត្រ',
    saveChanges: 'រក្សាទុកការផ្លាស់ប្ដូរ',
    allStatuses: 'គ្រប់ស្ថានភាព',
    allTypes: 'គ្រប់ប្រភេទ',
    allBranches: 'គ្រប់សាខា',
    allUsers: 'គ្រប់អ្នកប្រើ',
    statusFilter: 'ស្ថានភាព',
    typeFilter: 'ប្រភេទ',
    branchFilter: 'សាខា',
    userFilter: 'អ្នកប្រើ',
    fromDate: 'ចាប់ពី',
    toDate: 'រហូតដល់',
    apply: 'អនុវត្ត',
    loading: 'កំពុងផ្ទុក…',
    runReport: 'ដំណើរការរបាយការណ៍',
    ruleName: 'ឈ្មោះ *',
    ruleNamePlaceholder: 'ឧ. Sales Rep 5%',
    ruleType: 'ប្រភេទ *',
    ruleAppliesTo: 'អនុវត្តលើ',
    priorityLabel: 'អាទិភាព',
    activeLabel: 'សកម្ម',
    rulesCount: '{{n}} វិធាន',
    types: {
      ownerBusiness: 'ម្ចាស់អាជីវកម្ម',
      ownerBranch: 'ម្ចាស់សាខា',
      salesRep: 'អ្នកតំណាងផ្នែកលក់',
      customerDiscount: 'បញ្ចុះតម្លៃអតិថិជន',
      custom: 'កំណត់ខ្លួនឯង',
    },
    appliesToOptions: {
      all: 'ទាំងអស់',
      category: 'ប្រភេទ',
      product: 'ផលិតផល',
      branch: 'សាខា',
    },
    columns: {
      id: 'លេខ',
      type: 'ប្រភេទ',
      user: 'អ្នកប្រើ',
      branch: 'សាខា',
      invoice: 'វិក្កយបត្រ',
      baseAmount: 'ចំនួនមូលដ្ឋាន',
      rate: 'អត្រា',
      amount: 'ចំនួន',
      status: 'ស្ថានភាព',
      actions: 'សកម្មភាព',
      paidAt: 'បានបង់នៅ',
      product: 'ផលិតផល',
      sku: 'SKU',
      count: 'ចំនួន',
      name: 'ឈ្មោះ',
      created: 'បានបង្កើត',
      notes: 'កំណត់ចំណាំ',
    },
    status: {
      pending: 'រង់ចាំ',
      approved: 'បានអនុម័ត',
      paid: 'បានបង់',
      cancelled: 'បានបោះបង់',
    },
  },

  // ── Payments ──────────────────────────────────────────────────
  payments: {
    title: 'ការទូទាត់',
    subtitle: 'ចំនួន វិធី សមតុល្យវិក្កយបត្រ និងការជំពាក់',
    records: 'កំណត់ត្រា',
    list: 'បញ្ជីការទូទាត់',
    analytics: 'ការវិភាគ',
    paymentNumber: 'លេខទូទាត់',
    paymentTransaction: 'ប្រតិបត្តិការទូទាត់',
    refundTransaction: 'ប្រតិបត្តិការសង',
    noPayments: 'រកមិនឃើញការទូទាត់',
    allMethods: 'គ្រប់វិធី',
    allStatus: 'គ្រប់ស្ថានភាព',
    allTypes: 'គ្រប់ប្រភេទ',
    allBranches: 'គ្រប់សាខា',
    yourBranch: 'សាខារបស់អ្នក',
    showingBranchOnly: '— បង្ហាញការទូទាត់របស់សាខាអ្នក',
    byBranch: 'តាមសាខា',
    byMethod: 'វិធី',
    unassigned: 'មិនបានចាត់តាំង',
    unknown: 'មិនស្គាល់',
    other: 'ផ្សេង',
    done: 'រួច',
    refund: 'ការសង',
    failedLoad: 'បរាជ័យក្នុងការផ្ទុកការទូទាត់',
    collected: 'ប្រមូលបាន',
    pending: 'រង់ចាំ',
    refunded: 'បានសង',
    failed: 'បរាជ័យ',
    netCollected: 'ប្រមូលសុទ្ធ',
    khrCollected: 'ប្រមូលបាន (រៀល)',
    branches: 'សាខា',
    methods: 'វិធី',
    withActivity: 'មានសកម្មភាព',
    paymentMethods: 'វិធីទូទាត់',
    fromDate: 'ចាប់ពីថ្ងៃ',
    toDate: 'រហូតដល់ថ្ងៃ',
    transactions: 'ប្រតិបត្តិការ',
    searchPlaceholder: 'ស្វែងរក # ទូទាត់ អតិថិជន លេខយោង...',
    viewDetail: 'មើលលម្អិត',
    columns: {
      paymentNum: 'លេខទូទាត់',
      invoice: 'វិក្កយបត្រ',
      customer: 'អតិថិជន',
      branch: 'សាខា',
      amount: 'ចំនួន',
      method: 'វិធី',
      currency: 'រូបិយប័ណ្ណ',
      type: 'ប្រភេទ',
      status: 'ស្ថានភាព',
      date: 'កាលបរិច្ឆេទ',
      reference: 'លេខយោង',
      notes: 'កំណត់ចំណាំ',
      actions: 'សកម្មភាព',
    },
    status: {
      completed: 'បានបញ្ចប់',
      pending: 'រង់ចាំ',
      failed: 'បរាជ័យ',
      refunded: 'បានសង',
    },
    type: {
      payment: 'ការទូទាត់',
      refund: 'ការសង',
    },
  },

  // ── Promotions ────────────────────────────────────────────────
  promotions: {
    title: 'ការផ្សព្វផ្សាយ',
    newPromotion: 'ការផ្សព្វផ្សាយថ្មី',
    editPromotion: 'កែសម្រួលការផ្សព្វផ្សាយ',
    noPromotions: 'រកមិនឃើញការផ្សព្វផ្សាយ',
    name: 'ឈ្មោះ',
    description: 'ការពិពណ៌នា',
    type: 'ប្រភេទ',
    value: 'តម្លៃ',
    appliesTo: 'អនុវត្តលើ',
    startDate: 'ថ្ងៃចាប់ផ្ដើម',
    start: 'ចាប់ផ្ដើម',
    endDate: 'ថ្ងៃបញ្ចប់',
    end: 'បញ្ចប់',
    minPurchase: 'ការទិញអប្បបរមា',
    buyQty: 'ចំនួនទិញ',
    getQty: 'ចំនួនទទួល',
    isActive: 'សកម្ម',
    nameRequired: 'ទាមទារឈ្មោះ',
    enabled: 'បានបើក',
    disabled: 'បានបិទ',
    types: {
      percentage: 'ភាគរយ',
      fixed: 'ចំនួនថេរ',
      buyXGetY: 'ទិញ X ទទួល Y',
    },
    appliesOptions: {
      all: 'ទាំងអស់',
      category: 'ប្រភេទ',
      product: 'ផលិតផល',
      customerGroup: 'ក្រុមអតិថិជន',
    },
    columns: {
      name: 'ឈ្មោះ',
      type: 'ប្រភេទ',
      value: 'តម្លៃ',
      appliesTo: 'អនុវត្តលើ',
      start: 'ចាប់ផ្ដើម',
      end: 'បញ្ចប់',
      status: 'ស្ថានភាព',
    },
  },

  // ── Currencies & Exchange Rates ───────────────────────────────
  currencies: {
    title: 'រូបិយប័ណ្ណ & អត្រាប្ដូររូបិយប័ណ្ណ',
    subtitle: '{{c}} រូបិយប័ណ្ណ · {{r}} អត្រាសកល · {{b}} អត្រាសាខា',
    tabCurrencies: 'រូបិយប័ណ្ណ',
    tabRates: 'អត្រាសកល',
    tabBranchRates: 'អត្រាសាខា',
    code: 'លេខកូដ',
    name: 'ឈ្មោះ',
    symbol: 'និមិត្តសញ្ញា',
    isDefault: 'លំនាំដើម',
    isActive: 'សកម្ម',
    fromCurrency: 'ពី',
    toCurrency: 'ទៅ',
    rate: 'អត្រា',
    effectiveDate: 'ថ្ងៃចូលជាធរមាន',
    defaultLabel: 'លំនាំដើម',
    noCurrencies: 'រកមិនឃើញរូបិយប័ណ្ណ',
    noRates: 'រកមិនឃើញអត្រា',
    noBranchRates: 'រកមិនឃើញអត្រាសាខា',
    newCurrency: 'រូបិយប័ណ្ណថ្មី',
    editCurrency: 'កែសម្រួលរូបិយប័ណ្ណ',
    newRate: 'អត្រាថ្មី',
    editRate: 'កែសម្រួលអត្រា',
    newBranchRate: 'អត្រាសាខាថ្មី',
    editBranchRate: 'កែសម្រួលអត្រាសាខា',
    addCurrency: 'បន្ថែមរូបិយប័ណ្ណ',
    addRate: 'បន្ថែមអត្រាសកល',
    addBranchRate: 'បន្ថែមអត្រាសាខា',
    globalRatesDesc: 'អត្រាប្ដូររូបិយប័ណ្ណទូទៅ ប្រើជាលំនាំដើមសម្រាប់គ្រប់សាខា',
    branchRatesDesc: 'អត្រាប្ដូររូបិយប័ណ្ណប្រចាំសាខា លើសពីអត្រាសកល',
    branchRateOverride: 'អត្រាសាខាពិសេស',
    usesGlobalRate: 'ប្រើអត្រាសកល',
    latestRate: 'អត្រាចុងក្រោយ',
    previousRate: 'អត្រាមុន',
    rateChange: 'ការផ្លាស់ប្ដូរ',
    notes: 'កំណត់ចំណាំ',
    notesPlaceholder: 'កំណត់ចំណាំ (ស្រេចចិត្ត)...',
    branch: 'សាខា',
    allBranches: 'គ្រប់សាខា',
    setDefault: 'កំណត់ជាលំនាំដើម',
    activateLabel: 'សកម្ម',
    currencyUpdated: 'បានធ្វើបច្ចុប្បន្នភាពរូបិយប័ណ្ណ',
    rateCreated: 'បានបង្កើតអត្រា',
    rateUpdated: 'បានធ្វើបច្ចុប្បន្នភាពអត្រា',
    rateDeleted: 'បានលុបអត្រា',
    branchRateCreated: 'បានបង្កើតអត្រាសាខា',
    branchRateUpdated: 'បានធ្វើបច្ចុប្បន្នភាពអត្រាសាខា',
    branchRateDeleted: 'បានលុបអត្រាសាខា',
    confirmDelete: 'លុបអត្រានេះ?',
    createdBy: 'បង្កើតដោយ',
    noPermission: 'អ្នកមិនមានសិទ្ធិគ្រប់គ្រងរូបិយប័ណ្ណ។',
    filterBranch: 'តម្រងតាមសាខា',
    filterCurrency: 'តម្រងតាមរូបិយប័ណ្ណ',
    rateHistory: 'ប្រវត្តិអត្រា',
    currentRate: 'អត្រាបច្ចុប្បន្ន',
    columns: {
      code: 'លេខកូដ',
      name: 'ឈ្មោះ',
      symbol: 'និមិត្តសញ្ញា',
      default: 'លំនាំដើម',
      status: 'ស្ថានភាព',
      from: 'ពី',
      to: 'ទៅ',
      rate: 'អត្រា',
      date: 'ថ្ងៃចូលជាធរមាន',
      notes: 'កំណត់ចំណាំ',
      branch: 'សាខា',
      createdBy: 'បង្កើតដោយ',
      actions: 'សកម្មភាព',
    },
  },

  // ── Master Data ───────────────────────────────────────────────
  masterData: {
    title: 'ទិន្នន័យមេ',
    subtitle: 'គ្រប់គ្រងប្រភេទ ឯកតា ម៉ាក & ក្រុមអតិថិជន',
    categories: 'ប្រភេទ',
    uom: 'ឯកតារង្វាស់',
    unitsOfMeasure: 'ឯកតារង្វាស់',
    brands: 'ម៉ាក',
    customerGroups: 'ក្រុមអតិថិជន',
    addCategory: 'បន្ថែមប្រភេទ',
    newCategory: 'ប្រភេទថ្មី',
    editCategory: 'កែសម្រួលប្រភេទ',
    deleteCategory: 'លុបប្រភេទ',
    categoryName: 'ឈ្មោះប្រភេទ',
    categoryImage: 'រូបប្រភេទ',
    newUom: 'ឯកតារង្វាស់ថ្មី',
    editUom: 'កែសម្រួលឯកតារង្វាស់',
    deleteUom: 'លុបឯកតារង្វាស់',
    unitName: 'ឈ្មោះឯកតា',
    newBrand: 'ម៉ាកថ្មី',
    editBrand: 'កែសម្រួលម៉ាក',
    deleteBrand: 'លុបម៉ាក',
    newCustomerGroup: 'ក្រុមអតិថិជនថ្មី',
    editCustomerGroup: 'កែសម្រួលក្រុមអតិថិជន',
    deleteGroup: 'លុបក្រុម',
    groupName: 'ឈ្មោះក្រុម',
    parentCategory: 'ប្រភេទមេ',
    noneTopLevel: '— គ្មាន (កម្រិតខ្ពស់) —',
    sortOrder: 'លំដាប់តម្រៀប',
    abbreviation: 'អក្សរកាត់',
    abbr: 'អក្សរកាត់',
    factor: 'ចំណែក',
    conversionFactor: 'ចំណែករូបាន',
    baseUom: 'ឯកតាមូលដ្ឋាន',
    website: 'វេបសាយ',
    discountPercent: 'ភាគរយបញ្ចុះតម្លៃ',
    discountGroupDesc: 'ភាគរយបញ្ចុះតម្លៃសម្រាប់ក្រុមនេះ',
    creditLimit: 'ដែនកំណត់ឥណទាន',
    nameRequired: 'ទាមទារឈ្មោះ',
    nameAbbrRequired: 'ទាមទារឈ្មោះ និងអក្សរកាត់',
    nameCodeRequired: 'ទាមទារឈ្មោះ និងលេខកូដ',
    searchCategories: 'ស្វែងរកប្រភេទ...',
    searchUom: 'ស្វែងរកឯកតា...',
    searchBrands: 'ស្វែងរកម៉ាក...',
    searchGroups: 'ស្វែងរកក្រុម...',
    image: 'រូបភាព',
    maxFileSize: 'អតិបរមា 5MB',
    uploadFailed: 'បញ្ចូលរូបភាពបរាជ័យ',
    uploaded: 'បានបញ្ចូល',
    isActive: 'សកម្ម',
    topLevel: 'កម្រិតខ្ពស់',
    optionalDescription: 'ការពិពណ៌នា (ស្រេចចិត្ត)...',
    briefDescription: 'ការពិពណ៌នាខ្លី',
    columns: {
      name: 'ឈ្មោះ',
      abbreviation: 'អក្សរកាត់',
      factor: 'ចំណែក',
      status: 'ស្ថានភាព',
      website: 'វេបសាយ',
      discount: 'បញ្ចុះតម្លៃ',
      credit: 'ឥណទាន',
    },
  },

  // ── Reports ──────────────────────────────────────────────────
  reports: {
    title: 'របាយការណ៍',
    subtitle: 'ការវិភាគអាជីវកម្មទូលំទូលាយ',
    salesReport: 'របាយការណ៍ការលក់',
    orderReport: 'របាយការណ៍បញ្ជាទិញ',
    customerReport: 'របាយការណ៍អតិថិជន',
    dateRange: 'ជួរកាលបរិច្ឆេទ',
    groupBy: 'ដំណើរការតាម',
    runReport: 'ដំណើរការរបាយការណ៍',
    exportCsv: 'នាំចេញ CSV',
    noPermission: 'អ្នកគ្មានសិទ្ធិមើលរបាយការណ៍។',
    groups:{ pos:'POS', sales:'ការលក់', customers:'អតិថិជន', inventory:'សន្និធិ', finance:'ហិរញ្ញវត្ថុ' },
    tabs:{
      posSummary:'សង្ខេប POS', posSessions:'វគ្គ POS', cashRegister:'បញ្ជីសាច់ប្រាក់',
      salesOrders:'បញ្ជាទិញ', salesInvoices:'វិក្កយបត្រ', customers:'អតិថិជន',
      productSales:'ការលក់ផលិតផល', stock:'កម្រិតស្តុក', vendors:'អ្នកផ្គត់ផ្គង់',
      payments:'ការទូទាត់', commissions:'កម្រៃជើងសារ',
    },
    today:'ថ្ងៃនេះ', thisMonth:'ខែនេះ', last30:'30 ថ្ងៃចុងក្រោយ', thisYear:'ឆ្នាំនេះ',
    allBranches:'គ្រប់សាខា', allStatus:'គ្រប់ស្ថានភាព', allCategories:'គ្រប់ប្រភេទ',
    refresh:'ផ្ទុកឡើងវិញ', loading:'កំពុងផ្ទុក…', noData:'គ្មានទិន្នន័យ',
    transactions:'ប្រតិបត្តិការ', totalSales:'ការលក់សរុប', totalDiscount:'បញ្ចុះតម្លៃសរុប',
    avgOrder:'ការបញ្ជាទិញជំទង់', totalSessions:'វគ្គសរុប', totalVariance:'ភាពខុសគ្នាសរុប',
    cashIn:'ប្រាក់ចូល', cashOut:'ប្រាក់ចេញ', net:'សុទ្ធ',
    totalOrders:'បញ្ជាទិញសរុប', revenue:'ចំណូល', discount:'បញ្ចុះតម្លៃ',
    totalInvoices:'វិក្កយបត្រសរុប', totalRevenue:'ចំណូលសរុប', totalPaid:'បានបង់សរុប',
    outstanding:'នៅជំពាក់', taxCollected:'ពន្ធដែលបានប្រមូល',
    uniqueCustomers:'អតិថិជនតែមួយ', customerRevenue:'ចំណូលពីអតិថិជន',
    avgPerCustomer:'ជំទង់ក្នុងម្នាក់', walkInRevenue:'ចំណូលពីអ្នកមក',
    productsSold:'ផលិតផលដែលបានលក់', totalProfit:'ចំណេញសរុប',
    skusTracked:'SKU ត្រូវបានតាមដាន', stockValue:'តម្លៃស្តុក',
    lowStock:'ស្តុកទាប', outOfStock:'អស់ស្តុក',
    totalVendors:'អ្នកផ្គត់ផ្គង់សរុប', payments:'ការទូទាត់',
    usdCollected:'ប្រមូលបាន USD', khrCollected:'ប្រមូលបាន KHR',
    records:'កំណត់ត្រា', totalAmount:'ចំនួនសរុប',
    pending:'កំពុងរង់ចាំ', approved:'បានអនុម័ត', paidOut:'បានបង់',
    paymentMethodBreakdown:'ការបែងចែកវិធីទូទាត់', byBranch:'តាមសាខា',
    sessionDetails:'លម្អិតវគ្គ', cashEntries:'ចំណាក់បញ្ជីសាច់ប្រាក់',
    topProducts:'ផលិតផលលេចធ្លោ', topCustomers:'អតិថិជនលេចធ្លោ',
    orderList:'បញ្ជីការបញ្ជាទិញ', invoiceList:'បញ្ជីវិក្កយបត្រ',
    invoiceStatusBreakdown:'ការបែងចែកស្ថានភាព',
    top10Customers:'អតិថិជន 10 ខ្ពស់ជាងគេ', customerBreakdown:'ការបែងចែកអតិថិជន',
    top10ByRevenue:'10 ខ្ពស់ជាងគេ', profitMargins:'ម៉ាសៈឡេចំណេញ',
    productSalesDetail:'លម្អិតការលក់ផលិតផល', stockLevels:'កម្រិតស្តុក',
    vendorSummary:'សង្ខេបអ្នកផ្គត់ផ្គង់', dailyCashFlow:'លំហូរសាច់ប្រាក់',
    paymentDetails:'លម្អិតការទូទាត់', commissionByPerson:'កម្រៃតាមបុគ្គល',
    col:{
      method:'វិធី', txns:'ប្រតិបត្តិ', amount:'ចំនួន', branch:'សាខា',
      session:'វគ្គ', cashier:'អ្នកគិតលុយ', status:'ស្ថានភាព',
      opened:'បើក', closed:'បិទ', opening:'ការបើក', closing:'ការបិទ',
      expected:'រំពឹងទុក', variance:'ភាពខុសគ្នា', sales:'ការលក់',
      type:'ប្រភេទ', user:'អ្នកប្រើ', notes:'កំណត់ចំណាំ', date:'កាលបរិច្ឆេទ',
      orderNum:'លេខបញ្ជាទិញ', customer:'អតិថិជន', subtotal:'សរុបរង',
      tax:'ពន្ធ', total:'សរុប', items:'ទំនិញ', invoiceNum:'លេខវិក្កយបត្រ',
      dueDate:'ថ្ងៃកំណត់', paid:'បានបង់', balance:'សមតុល្យ',
      phone:'ទូរស័ព្ទ', pos:'POS', invoices:'វិក្កយបត្រ', last:'ចុងក្រោយ',
      product:'ផលិតផល', sku:'SKU', category:'ប្រភេទ',
      qtySold:'ចំនួនលក់', profit:'ចំណេញ', margin:'ម៉ាសៈឡេ',
      reorder:'ចំណាត់ការ', safety:'សុវត្ថិភាព', value:'តម្លៃ',
      vendor:'អ្នកផ្គត់ផ្គង់', products:'ផលិតផល', stock:'ស្តុកសរុប',
      payNum:'លេខទូទាត់', invoice:'វិក្កយបត្រ', orig:'ដើម',
      salesperson:'អ្នកលក់', commission:'កម្រៃ',
    },
    filter:{ lowStock:'ស្តុកទាប', outOfStock:'អស់ស្តុក', all:'ទាំងអស់' },
  },

  // ── Settings ─────────────────────────────────────────────────
  settings: {
    title: 'ការកំណត់ប្រព័ន្ធ',
    subtitle: 'ការកំណត់ & ការជូនដំណឹង Telegram',
    general: 'ទូទៅ',
    generalSettings: 'ការកំណត់ទូទៅ',
    companyName: 'ឈ្មោះក្រុមហ៊ុន',
    notifications: 'ការជូនដំណឹង',
    notificationLog: 'កំណត់ហេតុការជូនដំណឹង',
    telegram: 'Telegram',
    telegramAlerts: 'ការជូនដំណឹង Telegram',
    telegramChatId: 'Telegram Chat ID',
    botToken: 'Bot Token',
    testConnection: 'សាកល្បងការតភ្ជាប់',
    sendTest: 'ផ្ញើសាកល្បង',
    configure: 'កំណត់',
    connected: 'បានភ្ជាប់',
    noConfig: 'មិនទាន់កំណត់ Chat ID',
    noConfigDesc: 'មិនទាន់កំណត់ Chat ID — ចុច កំណត់ ដើម្បីរៀបចំ',
    notConfigured: 'មិនទាន់កំណត់',
    events: 'ព្រឹត្តិការណ៍ជូនដំណឹង',
    eventsCount: '{{n}} ប្រភេទ',
    daily: 'របាយការណ៍ប្រចាំថ្ងៃ',
    dailySalesReport: 'របាយការណ៍លក់ប្រចាំថ្ងៃ',
    lowStockAlert: 'ការជូនដំណឹងស្តុកទាប',
    lowStock: 'ការជូនដំណឹងស្តុកទាប',
    largeDiscountAlert: 'ការជូនដំណឹងបញ្ចុះតម្លៃខ្ពស់',
    newOrdersNotif: 'ការបញ្ជាទិញថ្មី និងស្ថានភាព',
    sendNow: 'ផ្ញើឥឡូវ',
    chatId: 'Chat ID',
    customMessage: 'សារផ្ទាល់ខ្លួន (ស្រេចចិត្ត)',
    leaveBlankDefault: 'ទុកទទេ ដើម្បីប្រើសារសាកល្បងលំនាំដើម',
    save: 'រក្សាទុកការផ្លាស់ប្ដូរ',
    saved: 'បានរក្សាទុក',
    settingsSaved: 'បានរក្សាទុកការកំណត់',
    dailySent: 'បានផ្ញើរបាយការណ៍ប្រចាំថ្ងៃ!',
    lowStockSent: 'បានផ្ញើការជូនដំណឹងស្តុកទាប!',
    testSent: 'បានផ្ញើសារសាកល្បង!',
    sendFailed: 'ការផ្ញើបានបរាជ័យ',
    urlApplied: 'URL បានអនុវត្ត',
    chooseFile: 'ជ្រើសរើសឯកសារ',
    logoUrl: 'URL រូបអង្គភាព',
    logoUploaded: 'បានបញ្ចូលរូបអង្គភាព',
    discountThreshold: 'ដែនកំណត់ការបញ្ចុះតម្លៃ (%)',
    discountAlertDesc: 'ការជូនដំណឹងជាក់ស្ដែង នៅពេលការបញ្ចុះតម្លៃលើស %',
    endOfDayDesc: 'សង្ខេបចុងថ្ងៃ: វិក្កយបត្រ POS ការប្រមូល ការជំពាក់',
    english: 'អង់គ្លេស',
    khmer: 'ខ្មែរ',
    automatic: 'ស្វ័យប្រវត្តិ',
    scheduled: 'កំណត់ពេល',
    unread: 'មិនទាន់អាន',
    markRead: 'សម្គាល់ថាបានអាន',
    // Bot status
    botConnected: 'Bot បានភ្ជាប់',
    botInvalid: 'Bot Token មិនត្រឹមត្រូវ',
    botNotConfigured: 'Bot មិនទាន់កំណត់',
    botCheckStatus: 'កំពុងពិនិត្យស្ថានភាព Bot...',
    botTokenDesc: 'កំណត់ TELEGRAM_BOT_TOKEN ក្នុង .env ដើម្បីបើកការជូនដំណឹង',
    botInvalidDesc: 'TELEGRAM_BOT_TOKEN ត្រូវបានកំណត់ ប៉ុន្តែបានត្រឡប់កំហុស — ពិនិត្យ token ឡើងវិញ',
    botApiReady: 'Telegram Bot API រួចរាល់',
    refresh: 'ផ្ទុកឡើងវិញ',
    // Branch telegram config
    branchTelegramConfig: 'ការកំណត់ Telegram សាខា',
    branchTelegramDesc: 'សាខានីមួយៗត្រូវការ Telegram Chat ID ផ្ទាល់ខ្លួន',
    branchTelegramHint: 'ទទួល Chat ID ដោយផ្ញើទៅ @userinfobot នៅ Telegram',
    configured: 'បានកំណត់',
    noBranches: 'រកមិនឃើញសាខា',
    yourBranchOnly: 'អ្នកមើលបានតែ Chat ID សាខារបស់អ្នក',
    // Notification events
    cashRegisterClosed: 'ម៉ាស៊ីនគិតប្រាក់បានបិទ',
    cashRegisterClosedDesc: 'សង្ខេបវគ្គពេញ: ការលក់ ការសង និងភាពខុស',
    invoiceCreated: 'វិក្កយបត្របានបង្កើត',
    invoiceCreatedDesc: 'ឈ្មោះអតិថិជន សរុប ថ្ងៃផុតកំណត់ និងអ្នកបង្កើត',
    saleOrder: 'បញ្ជាទិញ',
    saleOrderDesc: 'ការបញ្ជាទិញថ្មី និងការផ្លាស់ប្ដូរស្ថានភាព',
    paymentReceived: 'ទទួលបានការទូទាត់',
    paymentReceivedDesc: 'ចំនួន វិធី សមតុល្យ និងការជំពាក់',
    dailyReport: 'របាយការណ៍ប្រចាំថ្ងៃ',
    dailyReportDesc: 'សង្ខេបចុងថ្ងៃ: វិក្កយបត្រ POS ការប្រមូល',
    lowStockDesc: 'ផលិតផលក្រោមកម្រិតបញ្ជាទិញ ក្រុមតាមសាខា',
    largeDiscount: 'ការបញ្ចុះតម្លៃខ្ពស់',
    largeDiscountDesc: 'ការជូនដំណឹងជាក់ស្ដែង ពេលការបញ្ចុះតម្លៃលើស %',
    // Test message
    sendTestMessage: 'ផ្ញើសារសាកល្បង',
    sendTestDesc: 'ពិនិត្យការតភ្ជាប់ Telegram របស់សាខា',
    selectBranch: '— ជ្រើសសាខា —',
    sendTestBtn: 'ផ្ញើសាកល្បង',
    sending: 'កំពុងផ្ញើ...',
    // Manual triggers
    manualTriggers: 'ការផ្ញើដោយដៃ',
    manualTriggersDesc: 'ផ្ញើរបាយការណ៍ដោយបង្ខំទៅគ្រប់សាខាដែលបានកំណត់',
    autoSchedule: 'ពេលវេលាស្វ័យប្រវត្តិ',
    discountThresholdLabel: 'ដែនកំណត់ការបញ្ចុះតម្លៃ',
    // Notification log
    all: 'ទាំងអស់',
    total: 'សរុប',
    unreadLabel: 'មិនទាន់អាន',
    telegramChannel: 'Telegram',
    systemChannel: 'ប្រព័ន្ធ',
    read: 'បានអាន',
    deleteNotif: 'លុបការជូនដំណឹង',
    // Edit / configure
    editChatId: 'កែ Chat ID',
    setChatId: 'កំណត់ Chat ID',
    testSend: 'សាកល្បង',
    removeChatId: 'យក Chat ID ចេញ',
    saveChatId: 'រក្សាទុក',
    cancelEdit: 'បោះបង់',
  },

  // ── Users ────────────────────────────────────────────────────
  users: {
    title: 'អ្នកប្រើប្រាស់',
    titleFull: 'អ្នកប្រើប្រាស់ តួនាទី & ការគ្រប់គ្រងការចូលប្រើ',
    subtitle: '{{users}} នាក់ · {{roles}} តួនាទី',
    newUser: 'អ្នកប្រើប្រាស់ថ្មី',
    addUser: 'បន្ថែមអ្នកប្រើ',
    // Added v17: inline role assign + tabs
    assignRole: 'ផ្ដល់តួនាទី',
    roleAssigned: 'បានធ្វើបច្ចុប្បន្នភាពតួនាទី',
    roleAssignFailed: 'បរាជ័យក្នុងការធ្វើបច្ចុប្បន្នភាពតួនាទី',
    noRole: '— គ្មានតួនាទី —',
    usersWithRole: '{{n}} អ្នកប្រើ',
    usersWithRolePlural: '{{n}} អ្នកប្រើ',
    tabs: {
      users: 'អ្នកប្រើ',
      roles: 'តួនាទី និងសិទ្ធិ',
      matrix: 'ម៉ាទ្រីសសិទ្ធិ',
      audit: 'កំណត់ហេតុ Audit',
      logins: 'ប្រវត្តិចូលប្រើ',
    },
    quickTemplate: 'ផ្ទុករហ័សពីគំរូ',
    permCount: '{{n}} នៃ {{total}} បានជ្រើស',
    newRole: 'តួនាទីថ្មី',
    createUser: 'បង្កើតអ្នកប្រើ',
    editUser: 'កែសម្រួលអ្នកប្រើ',
    deleteUser: 'លុបអ្នកប្រើ',
    firstName: 'នាមខ្លួន',
    firstNameReq: 'នាមខ្លួន *',
    lastName: 'នាមត្រកូល',
    email: 'អ៊ីមែល',
    emailReq: 'អ៊ីមែល *',
    role: 'តួនាទី',
    roleReq: 'តួនាទី *',
    selectRole: '— ជ្រើសរើសតួនាទី —',
    branch: 'សាខា',
    noBranch: '— គ្មានសាខា —',
    lockedBranch: '(ចាក់សោក្នុងសាខារបស់អ្នក)',
    phone: 'ទូរស័ព្ទ',
    commissionRate: 'អត្រាកម្រៃ',
    language: 'ភាសា',
    password: 'ពាក្យសម្ងាត់',
    passwordReq: 'ពាក្យសម្ងាត់ *',
    newPassword: 'ពាក្យសម្ងាត់ថ្មី (ទុកទទេ = មិនផ្លាស់ប្ដូរ)',
    passwordRequired: 'ទាមទារពាក្យសម្ងាត់',
    nameEmailRequired: 'ទាមទារឈ្មោះ និងអ៊ីមែល',
    isActive: 'សកម្ម',
    allRoles: 'គ្រប់តួនាទី',
    allBranches: 'គ្រប់សាខា',
    noUsers: 'រកមិនឃើញអ្នកប្រើ',
    searchPlaceholder: 'ស្វែងរកតាមឈ្មោះ ឬ អ៊ីមែល...',
    activate: 'ដំណើរការ',
    deactivate: 'បិទ',
    activated: 'បានដំណើរការ',
    deactivated: 'បានបិទ',
    created: 'បានបង្កើតអ្នកប្រើ',
    updated: 'បានធ្វើបច្ចុប្បន្នភាពអ្នកប្រើ',
    deleted: 'បានលុបអ្នកប្រើ',
    assigned: 'បានចាត់តាំងអ្នកប្រើ',
    removed: 'បានដកចេញ',
    failedLoad: 'បរាជ័យក្នុងការផ្ទុកអ្នកប្រើ',
    failedUpdateStatus: 'បរាជ័យក្នុងការធ្វើបច្ចុប្បន្នភាពស្ថានភាព',
    outsideBranch: 'នៅខាងក្រៅសាខារបស់អ្នក — មើលប៉ុណ្ណោះ',
    branchScopedView: 'ទិដ្ឋភាពកំណត់ក្នុងសាខា',
    canOnlyManage: 'អ្នកអាចគ្រប់គ្រងអ្នកប្រើក្នុងសាខាដែលបានចាត់តាំងប៉ុណ្ណោះ',
    restricted: 'ត្រូវបានកំណត់',
    tabUsers: 'អ្នកប្រើ',
    tabRoles: 'តួនាទី & សិទ្ធ',
    tabMatrix: 'តារាងសិទ្ធចូលប្រើ',
    tabAudit: 'កំណត់ហេតុ',
    tabLogins: 'ប្រវត្តិចូល',
    tableView: 'តារាង',
    cardsView: 'ប័ណ្ណ',
    yourBranchUsers: 'អ្នកប្រើសាខារបស់អ្នក',
    otherBranchUsers: 'អ្នកប្រើសាខាផ្សេង — ត្រូវបានកំណត់',
    rolesAndPermissions: 'តួនាទី & សិទ្ធ',
    accessMatrix: 'តារាងសិទ្ធចូលប្រើ',
    matrixDesc: '— បង្ហាញម៉ូឌុលដែលតួនាទីម្នាក់ៗអាចចូលប្រើ',
    ownerOnly: 'ម្ចាស់ប៉ុណ្ណោះ',
    hasAccess: 'មានសិទ្ធ',
    noAccess: 'គ្មានសិទ្ធ',
    topRowNote: 'ជួរលើ = សិទ្ធមើល · ជួរក្រោម = សិទ្ធបង្កើត/គ្រប់គ្រង',
    module: 'ម៉ូឌុល',
    permissions: 'សិទ្ធ',
    permissionCount: '{{count}} សិទ្ធ',
    roleDetailTitle: 'លម្អិតតួនាទី & ការគ្រប់គ្រង',
    createRole: 'បង្កើតតួនាទី',
    editRole: 'កែសម្រួលតួនាទី',
    deleteRole: 'លុបតួនាទី',
    roleCreated: 'បានបង្កើតតួនាទី',
    roleUpdated: 'បានធ្វើបច្ចុប្បន្នភាពតួនាទី',
    roleDeleted: 'បានលុបតួនាទី',
    roleName: 'ឈ្មោះតួនាទី *',
    roleDescription: 'ការពិពណ៌នា',
    loadTemplate: 'ផ្ទុកគំរូ',
    selectTemplate: 'ជ្រើសរើសគំរូ...',
    systemRole: 'ប្រព័ន្ធ',
    customRole: 'កំណត់ខ្លួនឯង',
    noRole: 'គ្មានតួនាទី',
    nameRequired: 'ទាមទារឈ្មោះ',
    branchScope: 'ការគ្រប់គ្រង',
    fullGlobalAccess: 'ចូលប្រើបានទាំងអស់',
    globalAllBranches: 'ស្នាក់ការ (គ្រប់សាខា)',
    allBranchesOwner: 'គ្រប់សាខា (ម្ចាស់)',
    branchScoped: 'កំណត់ក្នុងសាខា',
    branchScopedInherits: 'កំណត់ក្នុងសាខា (ទទួលតួនាទី)',
    restrictedBranch: 'ត្រូវបានកំណត់ក្នុងសាខាដែលបានចាត់តាំង',
    ownerGlobalAccess: 'ម្ចាស់ / ចូលប្រើទាំងអស់',
    scope: 'ការគ្រប់គ្រង',
    full: 'ពេញលេញ',
    partial: 'មួយផ្នែក',
    selectBranch: 'ជ្រើសរើសសាខា',
    auditLogs: 'កំណត់ហេតុ',
    usersRoles: 'អ្នកប្រើ/តួនាទី',
    commLabel: 'កម្រៃ',
    lastLogin: 'ចូលចុងក្រោយ',
    loginHistory: 'ប្រវត្តិចូល',
    never: 'មិនដែល',
    managerName: 'ឈ្មោះអ្នកគ្រប់គ្រង',
    permGroups: {
      dashboard: 'ផ្ទាំងគ្រប់គ្រង',
      branches: 'សាខា',
      users: 'អ្នកប្រើ',
      customers: 'អតិថិជន',
      vendors: 'អ្នកផ្គត់ផ្គង់',
      products: 'ផលិតផល',
      inventory: 'ស្តុក/ស្ទុង',
      saleOrders: 'បញ្ជាទិញលក់',
      saleInvoices: 'វិក្កយបត្រលក់',
      posTerminal: 'ស្ថានីយ POS',
      posSessions: 'វគ្គ POS',
      commissions: 'កម្រៃជើងសារ',
      promotions: 'ការផ្សព្វផ្សាយ',
      payments: 'ការទូទាត់',
      reports: 'របាយការណ៍',
      settings: 'ការកំណត់',
      system: 'ប្រព័ន្ធ',
    },
    permLabels: {
      view: 'មើល',
      create: 'បង្កើត',
      edit: 'កែ',
      delete: 'លុប',
      manage: 'គ្រប់គ្រង',
      approve: 'អនុម័ត',
      cancel: 'បោះបង់',
      export: 'នាំចេញ',
      transfer: 'ផ្ទេរ',
      refund: 'សង',
      discount: 'បញ្ចុះតម្លៃ',
      payment: 'ការទូទាត់',
      analytics: 'ការវិភាគ',
      adjust: 'កែតម្រូវ',
      access: 'ចូលប្រើ',
      report: 'របាយការណ៍',
      financial: 'ហិរញ្ញវត្ថុ',
      sales: 'ការលក់',
      commission: 'កម្រៃ',
      inventory: 'ស្តុក',
      cash_io: 'ប្រាក់ចូល/ចេញ',
      loyalty: 'ភក្ដីភាព',
      open_session: 'បើកវគ្គ',
      close_session: 'បិទវគ្គ',
      sessions_view: 'មើលវគ្គ',
      sessions_report: 'របាយការណ៍វគ្គ',
      close_register: 'បិទម៉ាស៊ីន',
    },
    modules: {
      dashboard: 'ផ្ទាំងគ្រប់គ្រង',
      posTerminal: 'ស្ថានីយ POS',
      openPosSession: 'បើកវគ្គ POS',
      closePosSession: 'បិទវគ្គ POS',
      posSessionsView: 'មើលវគ្គ POS',
      saleOrders: 'បញ្ជាទិញលក់',
      saleInvoices: 'វិក្កយបត្រលក់',
      customers: 'អតិថិជន',
      vendors: 'អ្នកផ្គត់ផ្គង់',
      products: 'ផលិតផល',
      inventory: 'ស្តុក',
      commissions: 'កម្រៃជើងសារ',
      payments: 'ការទូទាត់',
      reports: 'របាយការណ៍',
      usersRoles: 'អ្នកប្រើ/តួនាទី',
      settings: 'ការកំណត់',
      auditLogs: 'កំណត់ហេតុ',
    },
    subLabels: {
      analytics: 'ការវិភាគ',
      discounts: 'បញ្ចុះតម្លៃ',
      registerOpen: 'ម៉ាស៊ីនបើក',
      forceClose: 'បិទបង្ខំ',
      matrixReports: 'របាយការណ៍',
      create: 'បង្កើត',
      createEdit: 'បង្កើត/កែ',
      manage: 'គ្រប់គ្រង',
      adjust: 'កែតម្រូវ',
      financial: 'ហិរញ្ញវត្ថុ',
      edit: 'កែប្រែ',
    },
    columns: {
      user: 'អ្នកប្រើ',
      role: 'តួនាទី',
      branchScope: 'សាខា / ការគ្រប់គ្រង',
      phone: 'ទូរស័ព្ទ',
      commission: 'កម្រៃ',
      lastLogin: 'ចូលចុងក្រោយ',
      status: 'ស្ថានភាព',
      actions: 'សកម្មភាព',
    },
    roles: {
      owner: 'ម្ចាស់',
      admin: 'អ្នកគ្រប់គ្រង',
      branchManager: 'អ្នកគ្រប់គ្រងសាខា',
      supervisor: 'អ្នកត្រួតពិនិត្យ',
      cashier: 'អ្នកគិតថ្លៃ',
      salesRep: 'អ្នកតំណាងផ្នែកលក់',
      salesRepresentative: 'អ្នកតំណាងផ្នែកលក់',
      accountant: 'គណនេយ្យករ',
      salesViewer: 'អ្នកមើលការលក់',
      stockViewer: 'អ្នកមើលស្តុក',
      inventoryStaff: 'បុគ្គលិកស្តុក',
      posManager: 'អ្នកគ្រប់គ្រង POS',
      financial: 'ហិរញ្ញវត្ថុ',
      custom: 'កំណត់ខ្លួនឯង',
    },
    audit: {
      entity: 'អង្គភាព',
      action: 'សកម្មភាព',
      oldValues: 'តម្លៃចាស់',
      newValues: 'តម្លៃថ្មី',
      id: 'លេខសម្គាល់',
      ip: 'IP',
      ipAddress: 'អាស័យដ្ឋាន IP',
      device: 'ឧបករណ៍',
      time: 'ពេលវេលា',
      allEntities: 'គ្រប់អង្គភាព',
      allActions: 'គ្រប់សកម្មភាព',
      auditLogDetail: 'លម្អិតកំណត់ហេតុ',
      actions: {
        create: 'បង្កើត',
        update: 'ធ្វើបច្ចុប្បន្នភាព',
        delete: 'លុប',
        statusChange: 'ប្ដូរស្ថានភាព',
        payment: 'ការទូទាត់',
        posClose: 'បិទ POS',
      },
      entities: {
        saleOrder: 'បញ្ជាទិញ',
        saleInvoice: 'វិក្កយបត្រ',
        posSession: 'វគ្គ POS',
        commission: 'កម្រៃ',
        product: 'ផលិតផល',
        user: 'អ្នកប្រើ',
      },
    },
  },

  // ── Branches ─────────────────────────────────────────────────
  branches: {
    title: 'សាខា',
    subtitle: '{{total}} សាខា · {{telegram}} Telegram · {{logo}} មានរូបសញ្ញា',
    subtitleOwner: 'គ្រប់សាខា — ទិដ្ឋភាពម្ចាស់',
    subtitleBranch: 'សាខារបស់អ្នក',
    newBranch: 'សាខាថ្មី',
    createBranch: 'បង្កើតសាខា',
    editBranch: 'កែសម្រួលសាខា',
    deleteBranch: 'លុបសាខា',
    code: 'លេខកូដ',
    branchCode: 'លេខកូដសាខា *',
    branchName: 'ឈ្មោះសាខា *',
    address: 'អាសយដ្ឋាន',
    fullAddress: 'អាសយដ្ឋានពេញ...',
    phone: 'ទូរស័ព្ទ',
    email: 'អ៊ីមែល',
    city: 'ទីក្រុង',
    isHeadquarters: 'ស្នាក់ការកណ្ដាល?',
    isActive: 'សកម្ម',
    yesHq: 'បាទ — ស្នាក់ការកណ្ដាល',
    noRegular: 'ទេ — សាខាធម្មតា',
    noBranches: 'រកមិនឃើញសាខា',
    noBranchAssigned: 'គ្មានសាខាដែលបានចាត់តាំងសម្រាប់គណនីរបស់អ្នក',
    searchPlaceholder: 'ស្វែងរកតាមឈ្មោះ លេខកូដ ទីក្រុង...',
    created: 'បានបង្កើតសាខា',
    updated: 'បានធ្វើបច្ចុប្បន្នភាពសាខា',
    failedLoad: 'បរាជ័យក្នុងការផ្ទុកសាខា',
    failedUpdateStatus: 'បរាជ័យក្នុងការធ្វើបច្ចុប្បន្នភាពស្ថានភាព',
    nameCodeRequired: 'ទាមទារឈ្មោះ និងលេខកូដ',
    managerName: 'ឈ្មោះអ្នកគ្រប់គ្រង',
    taxRate: 'អត្រាពន្ធ (%)',
    openingTime: 'ម៉ោងបើក',
    closingTime: 'ម៉ោងបិទ',
    logoUpload: 'រូបសញ្ញាសាខា',
    uploadOrUrl: 'បញ្ចូល ឬ URL',
    telegramNotifications: 'ការជូនដំណឹង Telegram',
    telegramChatId: 'Telegram Chat ID',
    telegramConfigured: 'បានកំណត់',
    telegramNotConfigured: 'មិនទាន់កំណត់',
    telegramSet: 'កំណត់',
    telegramEdit: 'កែ',
    telegramTest: 'សាកល្បង',
    telegramRemove: 'យកចេញ',
    telegramHint: 'ទទួល Chat ID ដោយផ្ញើសារទៅ @userinfobot នៅ Telegram។',
    assignedUsers: 'អ្នកប្រើដែលបានចាត់តាំង ({{n}})',
    assignUser: 'ចាត់តាំងអ្នកប្រើ',
    noUsersAssigned: 'គ្មានអ្នកប្រើដែលបានចាត់តាំងសម្រាប់សាខានេះ',
    selectUser: '— ជ្រើសអ្នកប្រើ —',
    userWillMove: 'បច្ចុប្បន្ននៅ {{branch}} — នឹងត្រូវផ្លាស់ទីនៅទីនេះ។',
    removeFromBranch: 'យកចេញពីសាខា',
    yourBranchOnly: 'អ្នកអាចមើលបានតែសាខាដែលបានចាត់តាំងប៉ុណ្ណោះ',
    viewingBranch: 'កំពុងមើល: {{name}}',
    deleteWarning: 'តើអ្នកប្រាកដចង់លុបសាខានេះ? មិនអាចទប់ស្កាត់បានទេ។',
    eMmenu: 'e-Menu',
    preview: 'មើលជាមុន',
    uploadLogoTitle: 'រូបសញ្ញាសាខា',
    useUrl: 'ប្រើ URL',
    uploadFile: 'បញ្ចូល',
    dropOrClick: 'ទម្លាក់ ឬ ចុច',
    imageFormats: 'PNG · JPG · WEBP · SVG · អតិបរមា 5MB',
    changeFile: 'ប្ដូររូប',
    chooseFile: 'ជ្រើសឯកសារ',
    logoUploaded: 'បានបញ្ចូលរូបសញ្ញា',
    uploadFailed: 'ការបញ្ចូលបានបរាជ័យ',
    urlApplied: 'URL បានអនុវត្ត',
    cannotLoadImage: 'មិនអាចផ្ទុករូបភាពពី URL នេះ',
    columns: {
      code: 'លេខកូដ',
      name: 'ឈ្មោះ',
      address: 'អាសយដ្ឋាន',
      phone: 'ទូរស័ព្ទ',
      hq: 'ស្នាក់ការ',
      status: 'ស្ថានភាព',
      actions: 'សកម្មភាព',
    },
  },

  // ── Audit Logs ────────────────────────────────────────────────
  audit: {
    title: 'កំណត់ហេតុសកម្មភាព',
    auditLogDetail: 'លម្អិតកំណត់ហេតុ',
    entity: 'អង្គភាព',
    action: 'សកម្មភាព',
    user: 'អ្នកប្រើ',
    branch: 'សាខា',
    date: 'កាលបរិច្ឆេទ',
    time: 'ពេលវេលា',
    device: 'ឧបករណ៍',
    channel: 'ប្រព័ន្ធ',
    ipAddress: 'អាស័យដ្ឋាន IP',
    description: 'ការពិពណ៌នា',
    noLogs: 'រកមិនឃើញកំណត់ហេតុ',
    statusChange: 'ការប្ដូរស្ថានភាព',
    saleOrder: 'បញ្ជាទិញ',
    saleInvoice: 'វិក្កយបត្រ',
    posSession: 'វគ្គ POS',
    oldValues: 'តម្លៃចាស់',
    newValues: 'តម្លៃថ្មី',
  },

  // ── Status labels (shared) ────────────────────────────────────
  status: {
    active: 'សកម្ម',
    inactive: 'អសកម្ម',
    open: 'បើក',
    closed: 'បិទ',
    pending: 'រង់ចាំ',
    completed: 'បានបញ្ចប់',
    cancelled: 'បានបោះបង់',
    draft: 'សំណាង',
    paid: 'បានបង់',
    voided: 'បានបោះបង់',
    refunded: 'បានសង',
    approved: 'បានអនុម័ត',
    failed: 'បរាជ័យ',
    sent: 'បានផ្ញើ',
    partial: 'មួយផ្នែក',
    overdue: 'ហួសកំណត់',
    processing: 'កំពុងដំណើរការ',
    shipped: 'បានដឹកជញ្ជូន',
    confirmed: 'បានបញ្ជាក់',
  },

  // ── UoM / Stock ───────────────────────────────────────────────
  uom: {
    selectUnit:       'ឯកតានៃការវាស់',
    baseUnit:         'ឯកតាមូលដ្ឋាន',
    alternativeUnits: 'ឯកតាជំនួស',
    conversionFactor: 'កត្តាបំលែង',
    example:          'ឧ. ១ ប្រអប់ = ២៤ ដប',
    soldAs:           'លក់ជា',
    stockDeductedAs:  'ស្តុកត្រូវបានកាត់ជា',
    baseUnits:        'ឯកតាមូលដ្ឋាន',
    factor:           '×{{n}} ការបំលែង',
    stockNote:        '{{sold}} {{uom}} = {{base}} ឯកតាមូលដ្ឋានត្រូវបានកាត់',
    insufficientStock:'ត្រូវការ {{need}} ឯកតាមូលដ្ឋាន ({{qty}} × {{factor}}), មាន: {{available}}',
    uomDeduction:     'ការបំលែងUoM ×{{factor}} (លក់ {{qty}}, កាត់ {{base}} ឯកតាមូលដ្ឋាន)',
  },

};

export default km;
